<template>
  <div class="animated revealUp" style="zoom: 0.9">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("add") }} {{ $t("fnbitems") }}</div>
      <router-link class="btn-blue" to="fnb-items"
        >{{ $t("fnbitems") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row mx-1">
        <div class="col-12 mx-0 new-border back pt-4 rounded-10">
          <div class="row">
            <div class="col-lg-4 col-xl-3 align-self-center">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="fnb_item.item_name"
                    @input="onChangeItemName($event, 'name')"
                    name="itemname"
                    id="itemname"
                    v-validate="'required'"
                    v-b-tooltip.hover
                    :title="$t('itemname')"
                  />
                  <label>{{ $t("name") }}</label>
                </div>
                <!--Tooltip :title="$t('itemname')" /-->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('itemname')">{{
                  errors.first("itemname")
                }}</span>
              </p>
            </div>
            <div class="col-lg-4 col-xl-3 align-self-center">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="fnb_item.alternate_lang_item_name"
                    name="alternate_lang_item_name"
                    id="alternate_lang_item_name"
                    v-validate="'required'"
                    v-b-tooltip.hover
                    :title="$t('itemname')"
                  />
                  <label>Alt. Item Name</label>
                </div>
                <!--Tooltip :title="$t('itemname')" /-->
              </div>
              <p class="error_message">
                <span
                  v-if="submitted && errors.has('alternate_lang_item_name')"
                  >{{ errors.first("alternate_lang_item_name") }}</span
                >
              </p>
            </div>

            <div class="col-lg-4 col-xl-3 align-self-center">
              <div class="dropdown-curve-container">
                <label
                  :class="fc_parent_label.length > 0 ? 'shift-up' : ''"
                  style="font-weight: 600"
                  >{{ $tc("category", 1) }}</label
                >
                <div class="d-flex justify-content-center align-items-center">
                  <b-dropdown
                    :text="fc_parent_label"
                    variant="dropdown-curve"
                    class="w-100"
                    v-b-tooltip.hover
                    :title="$t('fnbitems_foodcategory_tooltip')"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search Categories"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchFoodCategories()"
                        v-on:keydown="onSearchFoodCategories()"
                        v-on:search="onSearchFoodCategories()"
                        v-model="searchFoodCategories"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(fc, fcIndex) in ms_food_categories"
                      :key="fcIndex"
                      href="#"
                      @click="
                        fnb_item.fc_id = fc.fc_id;
                        fc_parent_label = fc.fc_category;
                        searchFoodCategories = '';
                        onSearchFoodCategories();
                      "
                      >{{ fc.fc_category }}</b-dropdown-item
                    >
                  </b-dropdown>
                  <!--Tooltip :title="$t('fnbitems_foodcategory_tooltip')" /-->
                </div>
                <p class="error_message">
                  <span v-if="submitted && fc_parent_label.length == 0"
                    >Please Select Food Category.</span
                  >
                </p>
              </div>
            </div>

            <div class="col-lg-4 col-xl-3 align-self-center">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="fnb_item.item_description"
                    @input="onChangeItemName($event, 'desc')"
                    name="itemdesc"
                    id="itemdesc"
                    v-validate="'required'"
                    v-b-tooltip.hover
                    :title="$t('fnbitems_itemdescription_tooltip')"
                  />
                  <label>{{ $t("description") }}</label>
                </div>
                <!--Tooltip :title="$t('fnbitems_itemdescription_tooltip')" /-->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('itemdesc')">{{
                  errors.first("itemdesc")
                }}</span>
              </p>
            </div>

            <div class="col-lg-2 col-xl-1 align-self-center">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    style="text-align: right"
                    placeholder="."
                    type="number"
                    v-model="fnb_item.fi_order"
                    name="fi_order"
                    id="fi_order"
                    v-validate=""
                  />
                  <label>{{ "Order" }}</label>
                </div>
              </div>
              <p class="error_message"></p>
            </div>

            <div class="col-lg-2 col-xl-2 align-self-center">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    style="text-align: right"
                    placeholder="."
                    type="number"
                    v-model="fnb_item.item_age_restriction"
                    name="item_age_restriction"
                    id="item_age_restriction"
                    v-validate=""
                  />
                  <label>{{ "Age Restriction" }}</label>
                </div>
              </div>
              <p class="error_message"></p>
            </div>

            <div class="col-lg-3 col-xl-2 align-self-center">
              <label class="mb-0 mr-3">{{ $t("Upload image") }}</label>
              <div class="d-flex align-items-center">
                <!-- <label for="file-selector3" class="file-selector w-100"> -->

                <button
                  class="fnb-btn-edit"
                  @click.prevent.stop="setModalData(280, 460)"
                >
                  Choose File
                </button>

                <label
                  style="display: none"
                  class="material-file-upload"
                  @click.prevent.stop="setModalData(280, 460)"
                >
                  <ImageGallery
                    v-bind:propImageName="fnb_item.item_name"
                    :img_desc="fnb_item.item_description"
                    :showPercentageLoader="true"
                    v-bind:openModal="showModal"
                    v-bind:set_height="set_height"
                    v-bind:set_width="set_width"
                    v-bind:category="fnb_item.item_is_veg ? 'Veg' : 'Non Veg'"
                    v-bind:menu="'A'"
                    :resetImgData="false"
                    :title="`Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`"
                  ></ImageGallery>
                </label>

                <img
                  width="40"
                  height="40"
                  class="rounded ml-2 mr-2"
                  @click="showFnbImage()"
                  @mouseover="showFnbImage()"
                  :src="_GetImagePath(fnb_item.item_image_url)"
                  v-if="
                    fnb_item.hasOwnProperty('item_image_url') &&
                    fnb_item.item_image_url
                  "
                />
                <img
                  v-else
                  width="35"
                  height="35"
                  class="rounded ml-2 mr-2"
                  alt="Empty Image"
                  src="@/assets/img/icons/empty-image.svg"
                />
              </div>
            </div>

            <div
              class="d-flex align-items-center col-lg-1 col-xl-1 align-self-center pl-0"
            >
              <b-form-checkbox
                v-model="fnb_item.item_is_active"
                type="checkbox"
                class="j-checkbox pb-0 mb-3"
                checked
              />

              <label class="mb-3 mr-2">{{ $t("active") }}</label>
            </div>
          </div>
        </div>

        <section class="mb-2 col-lg-12 col-xl-12 align-self-center">
          <div class="row bn-tabs-content">
            <div
              class="col-12 d-flex align-items-center mt-2 new-border back rounded-10 py-2 flex-wrap"
            >
              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="fnb_item.item_is_veg"
                    @change="onChangeIsVeg($event)"
                    type="checkbox"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                  >
                  </b-form-checkbox>
                  <label class="mb-0 mr-3">{{ $t("isveg") }}</label>
                </div>
              </div>

              <div
                class="fnb-flag align-self-center"
                v-if="fnb_item.item_is_veg"
              >
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="fnb_item.includes_egg"
                    style="padding-bottom: 0px"
                    type="checkbox"
                    class="j-checkbox"
                  >
                  </b-form-checkbox>
                  <label class="mb-0 mr-3">{{ $t("includesegg") }}</label>
                </div>
              </div>

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="fnb_item.is_package_item"
                    type="checkbox"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                  >
                  </b-form-checkbox>
                  <label class="mb-0 mr-3" style="white-space: nowrap">{{
                    $t("isPackageitem")
                  }}</label>
                </div>
              </div>

              <!-- <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.is_sundry"
                    unchecked-value="N"
                    value="Y"
                  >
                  </b-form-checkbox>
                  <label class="mb-0 mr-3" style="white-space: nowrap">{{
                    $t("isSundry")
                  }}</label>
                </div>
              </div> -->

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.is_combo"
                    unchecked-value="N"
                    value="Y"
                    @change="onClickCombo($event)"
                  >
                  </b-form-checkbox>
                  <span style="white-space: nowrap">{{ $t("isCombo") }}</span>
                </div>
              </div>

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.has_modifiers"
                    unchecked-value="N"
                    value="Y"
                    @change="onClickModifier($event)"
                  >
                  </b-form-checkbox>
                  <span style="white-space: nowrap">{{
                    $t("has_modifiers")
                  }}</span>
                </div>
              </div>

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    name="ready_to_serve"
                    id="ready_to_serve"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.ready_to_serve"
                    unchecked-value="N"
                    value="Y"
                  >
                  </b-form-checkbox>
                  <label
                    class="mb-0 mr-3"
                    for="ready_to_serve"
                    style="white-space: nowrap"
                    >{{ $t("isReadyToServe") }}</label
                  >
                </div>
              </div>

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    name="is_premier_item"
                    id="is_premier_item"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.is_premier_item"
                    unchecked-value="N"
                    value="Y"
                  >
                  </b-form-checkbox>
                  <label
                    class="mb-0 mr-3"
                    for="is_premier_item"
                    style="white-space: nowrap"
                    >{{ $t("is_premier_item") }}</label
                  >
                </div>
              </div>

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    name="is_non_sellable_product"
                    id="is_non_sellable_product"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.is_non_sellable_product"
                    unchecked-value="N"
                    value="Y"
                  >
                  </b-form-checkbox>
                  <label
                    class="mb-0 mr-3"
                    for="is_non_sellable_product"
                    style="white-space: nowrap"
                    >{{ $t("is_non_sellable_product") }}</label
                  >
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="col-12 combo-wrapper" v-if="fnb_item.is_combo == 'Y'">
          <div class="row px-0 mt-3" style="gap: 15px">
            <div class="section-title mt-3 mb-4">
              {{ "Combo" }}
            </div>

            <div class="align-self-center mb-2">
              <div class="dropdown-curve-container">
                <label
                  :class="selectedComboCategory.length > 0 ? 'shift-up' : ''"
                  style="font-weight: 600"
                  >{{ "Combo Category" }}</label
                >
                <multiselect
                  :options="ms_food_categories"
                  v-model="selectedComboCategory"
                  :searchable="true"
                  :multiple="true"
                  label="fc_category"
                  track-by="fc_id"
                  style="min-width: 210px"
                  @input="onSelectComboCategories($event, 'select')"
                  @remove="onSelectComboCategories($event, 'remove')"
                ></multiselect>
                <p
                  v-if="submitted && selectedComboCategory.length == 0"
                  class="error_message"
                >
                  Please Select Categories.
                </p>
              </div>
            </div>
            <div
              class="align-items-center d-flex mb-2 font-weight-bold text-primary"
              @click="onAddManualCategory(CinemaIndex)"
            >
              + ADD CATEGORY
            </div>
          </div>

          <div class="row mb-2 border-new back">
            <div
              class="row sec-1 m-2"
              v-for="(singleCinema, CinemaIndex) in CinemaPriceSettings"
              :key="CinemaIndex"
            >
              <div class="col-11">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <!-- SELECT CINEMA -->
                      <div class="col-lg-12 col-xl-3 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              CinemaPriceSettings[CinemaIndex].cinema_id &&
                              String(CinemaPriceSettings[CinemaIndex].cinema_id)
                                .length > 0
                                ? 'shift-up'
                                : ''
                            "
                            style="font-weight: 600"
                            >{{ $tc("cinema", 1) }}</label
                          >
                          <multiselect
                            :options="cinemaListFiltered"
                            v-model="singleCinema.selectedCinemas"
                            :searchable="true"
                            label="cine_name"
                            track-by="cine_id"
                            placeholder=""
                            @input="onDropdownChange($event, CinemaIndex)"
                            :allowEmpty="false"
                            :showLabels="false"
                            :disabled="isRoleID"
                          ></multiselect>
                          <p class="error_message">
                            <span
                              v-if="
                                submitted &&
                                singleCinema.selectedCinema.length == 0
                              "
                            >
                              Please Select Cinema.
                            </span>
                          </p>
                        </div>
                      </div>

                      <!-- SELECT RECIPE -->
                      <div class="col-lg-4 col-xl-2 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              CinemaPriceSettings[CinemaIndex].itemcost_price
                                .item_id &&
                              String(
                                CinemaPriceSettings[CinemaIndex].itemcost_price
                                  .item_id
                              ).length > 0
                                ? 'shift-up'
                                : ''
                            "
                            style="font-weight: 600"
                            >{{ $t("recipeoptional") }}
                          </label>
                          <div
                            class="d-flex justify-content-center align-items-center overFlowHide"
                          >
                            <multiselect
                              v-model="singleCinema.recipe_name"
                              @remove="
                                onRemoveFnbItem($event, CinemaIndex);
                                fnb_item.recipe_id = '';
                                singleCinema.recipe_label = '';
                              "
                              @select="
                                onSelectFnbItem($event, CinemaIndex);
                                fnb_item.recipe_id = $event.recipe_id;
                                singleCinema.recipe_label = $event.recipe_name;
                              "
                              :placeholder="
                                singleCinema.recipe_label &&
                                singleCinema.recipe_label.length > 0
                                  ? singleCinema.recipe_label
                                  : 'Recipe Optional'
                              "
                              :options="recipes"
                              label="recipe_name"
                              track-by="recipe_id"
                              :disabled="
                                role_id == 1 || role_id == 2
                                  ? false
                                  : singleCinema.cinemaFlag
                              "
                              :multiple="false"
                              :showLabels="true"
                              :searchable="true"
                              select-label="Select"
                              deselect-label="Remove"
                              v-b-tooltip.hover
                              :title="$t('fnbitems_tooltip')"
                            ></multiselect>
                          </div>
                          <p class="error_message">
                            <span></span>
                          </p>
                        </div>
                      </div>

                      <!-- ITEM COST PRICE -->
                      <div class="col-lg-4 col-xl-2 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="."
                              type="number"
                              style="text-align: right"
                              v-model="singleCinema.itemcost_price.costprice"
                              name="costprice"
                              id="costprice"
                            />
                            <label>{{ $t("itemcostprice") }}</label>
                          </div>
                          <!--Tooltip :title="$t('itemcostprice_costPrice')" /-->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('costprice')">{{
                            errors.first("costprice")
                          }}</span>
                        </p>
                      </div>

                      <!-- FNB PRICE -->
                      <div class="col-lg-3 col-xl-2 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="."
                              style="text-align: right"
                              v-model="singleCinema.ratecard.frc_amount"
                              v-on:keyup="
                                onChangeRatecardAmount($event, CinemaIndex)
                              "
                              type="number"
                              name="cardamount"
                              id="cardamount"
                              v-validate="{
                                required: 'required',
                                regex: '[0-9]|[0-9]*\\.[0-9]*$',
                              }"
                            />
                            <label>{{ $t("amount") }}</label>
                          </div>
                          <!--Tooltip :title="$t('tooltip')" /-->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('cardamount')">
                            {{ "Enter Valid Amount" }}
                          </span>
                        </p>
                      </div>

                      <!-- CHARGE SETTING NAME -->
                      <div class="col-lg-4 col-xl-3 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              CinemaPriceSettings[CinemaIndex]
                                .selectedChargeSettingName &&
                              String(
                                CinemaPriceSettings[CinemaIndex]
                                  .selectedChargeSettingName
                              ).length > 0
                                ? 'shift-up'
                                : ''
                            "
                          ></label>
                          <multiselect
                            :options="singleCinema.pas_setting_name_list"
                            :searchable="true"
                            :placeholder="
                              singleCinema.selectedChargeSettingName.length > 0
                                ? singleCinema.selectedChargeSettingName
                                : 'Charge'
                            "
                            label="pas_charge_setting_name"
                            track-by="pas_id"
                            @select="
                              onChangeSettingName($event, $event, CinemaIndex)
                            "
                            :allowEmpty="false"
                            :showLabels="false"
                          ></multiselect>
                          <p class="error_message">
                            <span
                              v-if="
                                submitted &&
                                singleCinema.selectedChargeSettingName.length ==
                                  0
                              "
                            >
                              Please Select Charge Setting Name.
                            </span>
                          </p>
                        </div>
                      </div>

                      <!-- CHARGE SETTINGS -->
                      <div class="col-md-12 col-xl-12 col-lg-12" v-if="false">
                        <div class="col-12">
                          <div class="row">
                            <table
                              class="col-xl-8"
                              v-if="
                                singleCinema &&
                                singleCinema.cinemaChargesList.length > 0
                              "
                            >
                              <tr
                                v-for="(
                                  cinemaCharge, cinemaChargesListIndex
                                ) in singleCinema.cinemaChargesList"
                                :key="cinemaChargesListIndex"
                                class="main_border_add"
                              >
                                <td
                                  style="
                                    padding: 4px 10px;
                                    color: black;
                                    font-weight: bold;
                                  "
                                >
                                  {{ cinemaCharge.ct_name }}
                                </td>

                                <td
                                  style="
                                    padding: 4px 10px;
                                    color: black;
                                    font-weight: bold;
                                    text-align: right;
                                  "
                                >
                                  {{ cinemaCharge.pas_charge_value
                                  }}{{
                                    cinemaCharge.pas_is_percentage == "Y"
                                      ? "%"
                                      : ""
                                  }}
                                </td>

                                <td
                                  style="
                                    padding: 4px 10px;
                                    color: black;
                                    font-weight: bold;
                                    text-align: right;
                                  "
                                >
                                  {{
                                    cinemaCharge.cinemacharges
                                      ? parseFloat(
                                          cinemaCharge.cinemacharges || 0
                                        ).toFixed(4)
                                      : 0
                                  }}
                                </td>
                              </tr>

                              <tr class="main_border_add">
                                <td style="padding: 4px 10px">
                                  <span class="font-weight-bold"
                                    >Net Amount:</span
                                  >
                                  <span style="color: black; font-weight: bold"
                                    >{{ currencyData.curr_code }}
                                    {{
                                      singleCinema.ratecard.frc_net_amount.toFixed(
                                        2
                                      )
                                    }}
                                  </span>
                                </td>

                                <td style="padding: 4px 10px">
                                  <span class="font-weight-bold"
                                    >Gross Total:</span
                                  >
                                  <span style="color: black; font-weight: bold"
                                    >{{ currencyData.curr_code }}
                                    {{
                                      singleCinema.ratecard.frc_total_amount.toFixed(
                                        2
                                      )
                                    }}</span
                                  >
                                </td>

                                <td style="padding: 4px 10px">
                                  <span class="font-weight-bold"
                                    >Food Cost %:</span
                                  >
                                  <span
                                    v-if="
                                      singleCinema.ratecard.frc_total_amount
                                    "
                                    style="color: black; font-weight: bold"
                                  >
                                    {{
                                      +parseFloat(
                                        (
                                          singleCinema.itemcost_price
                                            .costprice /
                                          singleCinema.ratecard.frc_total_amount
                                        ).toFixed(4) * 100
                                      ).toFixed(4)
                                    }}%
                                  </span>
                                </td>
                              </tr>
                            </table>

                            <div class="col-md-5 mb-4" v-if="false">
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                                  <label>{{ cinemaCharge.ct_name }}</label>
                                </div>
                              </div>
                              <!-- <p class="error_msg">Invalid Entry</p> -->
                            </div>
                            <div class="col-md-7" v-if="false">
                              <div class="row">
                                <div class="col-md-5">
                                  <div
                                    class="d-flex justify-content-center align-items-center p-3"
                                  >
                                    <label
                                      >{{ cinemaCharge.pas_charge_value
                                      }}{{
                                        cinemaCharge.pas_is_percentage == "Y"
                                          ? "%"
                                          : ""
                                      }}</label
                                    >
                                  </div>
                                </div>
                                <div class="col-md-5">
                                  <div
                                    class="d-flex justify-content-center align-items-center p-3"
                                  >
                                    <label>{{
                                      cinemaCharge.cinemacharges
                                        ? parseFloat(
                                            cinemaCharge.cinemacharges || 0
                                          ).toFixed(4)
                                        : 0
                                    }}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div
                          class="combo-box row"
                          v-for="(
                            category, categoryIndex
                          ) in singleCinema.combo_pack"
                          :key="categoryIndex"
                          v-if="singleCinema.combo_pack.length > 0"
                        >
                          <div class="col-md-2 col-sm-6">
                            <div class="d-flex align-items-center">
                              <div class="input-material">
                                <input
                                  type="text"
                                  disabled
                                  style="text-align: right"
                                  v-model="category.category_name"
                                  name="category_name"
                                  id="category_name"
                                />
                                <label>{{ "Category" }}</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-2 col-sm-6">
                            <div
                              class="d-flex align-items-center"
                              style="gap: 10px"
                            >
                              <div
                                class="input-material"
                                v-if="category.min_max_setting == 'Y'"
                              >
                                <input
                                  type="number"
                                  style="text-align: right"
                                  v-model="category.min_quantity"
                                  name="min_quantity"
                                  id="min_quantity"
                                />
                                <label>{{ "Min Qty" }}</label>
                              </div>
                              <div
                                class="input-material"
                                v-if="category.min_max_setting == 'Y'"
                              >
                                <input
                                  type="number"
                                  style="text-align: right"
                                  v-model="category.max_quantity"
                                  name="max_quantity"
                                  id="max_quantity"
                                />
                                <label>{{ "Max Qty" }}</label>
                              </div>
                              <div class="input-material" v-else>
                                <input
                                  type="number"
                                  style="text-align: right"
                                  v-model="category.quantity"
                                  name="item_qty"
                                  id="item_qty"
                                />
                                <label>{{ "Quantity" }}</label>
                              </div>
                            </div>
                            <div class="checkbox-box mt-2">
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  type="checkbox"
                                  :name="`min_max_setting_${categoryIndex}_${CinemaIndex}`"
                                  :id="`min_max_setting_${categoryIndex}_${CinemaIndex}`"
                                  class="j-checkbox"
                                  style="padding-bottom: 0px"
                                  v-model="category.min_max_setting"
                                  unchecked-value="N"
                                  value="Y"
                                >
                                </b-form-checkbox>
                                <label
                                  class="mb-0 mr-3"
                                  :for="`min_max_setting_${categoryIndex}_${CinemaIndex}`"
                                  style="white-space: nowrap"
                                  >{{ $t("min_max_setting") }}</label
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <div class="dropdown-curve-container">
                              <label
                                :class="'shift-up'"
                                style="font-weight: 600"
                                >{{ "Item" }}</label
                              >
                              <multiselect
                                :options="
                                  getCategoryItems(
                                    singleCinema,
                                    category.category_id,
                                    category,
                                    null
                                  )
                                "
                                v-model="category.default_item"
                                @select="
                                  onSelectDefaultItem(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'select'
                                  )
                                "
                                @remove="
                                  onSelectDefaultItem(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'remove'
                                  )
                                "
                                :searchable="true"
                                :multiple="false"
                                label="item_name"
                                track-by="item_id"
                              ></multiselect>
                              <p class="error_message">
                                <span
                                  v-if="
                                    getCategoryItems(
                                      singleCinema,
                                      category.category_id,
                                      category,
                                      null
                                    ).length == 0
                                  "
                                  >No Items For Selected Category</span
                                >
                                <span
                                  v-else-if="
                                    !category.default_item_id && submitted
                                  "
                                  >Please Select Item</span
                                >
                              </p>
                            </div>
                          </div>
                          <div class="col-md-5 col-sm-6">
                            <div class="dropdown-curve-container">
                              <label
                                :class="'shift-up'"
                                style="font-weight: 600"
                                >{{ "Alternate Items" }}</label
                              >
                              <multiselect
                                :options="
                                  getCategoryItems(
                                    singleCinema,
                                    category.category_id,
                                    category,
                                    'alternate'
                                  )
                                "
                                v-model="category.alternate_items"
                                :searchable="true"
                                :multiple="true"
                                label="item_name"
                                track-by="item_id"
                              ></multiselect>
                              <p class="error_message"></p>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="singleCinema.combo_pack.length == 0"
                          class="noCategory"
                        >
                          <span>Please Select Combo Category</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- OLD PRICE BREAKUP -->
                  <div class="col-md-12 col-xl-12 col-lg-12">
                    <div class="col-12">
                      <div class="row">
                        <table
                          class="col-xl-8 border old_price_backup_combo"
                          border
                          v-if="
                            singleCinema.combo_pack &&
                            singleCinema.combo_pack.length > 0 &&
                            singleCinema.combo_pack.some((x) => x.default_item)
                          "
                        >
                          <tr class="main_border_add bg_light">
                            <td>Item Name</td>
                            <td>Cost Price</td>
                            <td>Net Price</td>
                            <td>Tax Amt.</td>
                            <td>Gross</td>
                          </tr>
                          <tr
                            v-for="(
                              category_obj, itemCIndex
                            ) in singleCinema.combo_pack"
                            :key="itemCIndex"
                            class="main_border_add"
                            v-if="category_obj.default_item"
                          >
                            <td>
                              {{
                                category_obj.default_item["item_name"] || "-"
                              }}
                            </td>
                            <td>
                              {{
                                currFormat(
                                  category_obj.default_item["itc_cost_price"]
                                ) || "0.00"
                              }}
                            </td>
                            <td>
                              {{
                                currFormat(
                                  category_obj.default_item["fp_amount"]
                                ) || "0.00"
                              }}
                            </td>
                            <td>
                              {{
                                currFormat(
                                  parseFloat(
                                    category_obj.default_item[
                                      "fp_total_amount"
                                    ] || 0
                                  ) -
                                    parseFloat(
                                      category_obj.default_item["fp_amount"] ||
                                        0
                                    )
                                ) || "0.00"
                              }}
                            </td>
                            <td>
                              {{
                                currFormat(
                                  category_obj.default_item["fp_total_amount"]
                                ) || "0.00"
                              }}
                            </td>
                          </tr>

                          <tr class="main_border_add bg_light">
                            <td>Total</td>
                            <td>
                              {{
                                parseFloat(
                                  singleCinema.combo_pack.reduce(function (
                                    accumulator,
                                    { default_item }
                                  ) {
                                    return (
                                      accumulator +
                                      parseFloat(
                                        default_item["itc_cost_price"] || 0
                                      )
                                    );
                                  },
                                  0)
                                ).toFixed(MIN_FRACTION_DIGITS)
                              }}
                            </td>
                            <td style="padding: 4px 10px">
                              {{
                                parseFloat(
                                  singleCinema.combo_pack.reduce(function (
                                    accumulator,
                                    { default_item }
                                  ) {
                                    return (
                                      accumulator +
                                      parseFloat(default_item["fp_amount"] || 0)
                                    );
                                  },
                                  0)
                                ).toFixed(MIN_FRACTION_DIGITS)
                              }}
                            </td>
                            <td style="padding: 4px 10px">
                              {{
                                parseFloat(
                                  singleCinema.combo_pack.reduce(function (
                                    accumulator,
                                    { default_item }
                                  ) {
                                    return (
                                      accumulator +
                                      parseFloat(
                                        parseFloat(
                                          default_item["fp_total_amount"] || 0
                                        ) -
                                          parseFloat(
                                            default_item["fp_amount"] || 0
                                          )
                                      )
                                    );
                                  },
                                  0)
                                ).toFixed(MIN_FRACTION_DIGITS)
                              }}
                            </td>
                            <td style="padding: 4px 10px">
                              {{
                                parseFloat(
                                  singleCinema.combo_pack.reduce(function (
                                    accumulator,
                                    { default_item }
                                  ) {
                                    return (
                                      accumulator +
                                      parseFloat(
                                        default_item["fp_total_amount"] || 0
                                      )
                                    );
                                  },
                                  0)
                                ).toFixed(MIN_FRACTION_DIGITS)
                              }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- <div
                    class="col-lg-12 col-xl-12 d-flex align-items-center combo-inner-title mt-2"
                  >
                    {{ "Validity" }}
                  </div> -->

                  <!-- FROM DATE -->
                  <div class="col-lg-4 col-xl-2 align-self-center my-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="singleCinema.ms_fnb_price.fp_from_date"
                            @click="resetFromDate(CinemaIndex)"
                          >
                            ✖
                          </button>
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="singleCinema.ms_fnb_price.fp_from_date"
                            name="fdate1"
                            id="fdate1"
                            typeable
                            v-validate="'required'"
                            v-b-tooltip.hover
                            :title="$t('fnbpricing_fromdate')"
                          ></Datepicker>
                          <label
                            :class="
                              typeof singleCinema.ms_fnb_price.fp_from_date ===
                              'object'
                                ? 'active'
                                : ''
                            "
                            >From</label
                          >
                        </div>
                      </div>
                      <!--Tooltip :title="$t('fnbpricing_fromdate')" /-->
                    </div>
                    <p
                      v-if="submitted && errors.has('fdate1')"
                      class="error_message"
                    >
                      {{ errors.first("fdate1") }}
                    </p>
                  </div>

                  <!-- TO DATE -->
                  <div class="col-lg-4 col-xl-2 align-self-center my-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="singleCinema.ms_fnb_price.fp_to_date"
                            @click="resetToDate(CinemaIndex)"
                          >
                            ✖
                          </button>
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="singleCinema.ms_fnb_price.fp_to_date"
                            name="tdate1"
                            id="tdate1"
                            typeable
                            v-b-tooltip.hover
                            :title="$t('fnbpricing_todate')"
                          ></Datepicker>
                          <label
                            :class="
                              typeof singleCinema.ms_fnb_price.fp_to_date ===
                              'object'
                                ? 'active'
                                : ''
                            "
                            >To (Optional)</label
                          >
                        </div>
                      </div>
                    </div>
                    <!--p class="text-muted fs-12">({{ $t("optional") }})</p-->
                  </div>

                  <template v-if="showErpColumns">
                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.report_code"
                            name="report_code"
                            id="report_code"
                            v-validate=""
                          />
                          <label>{{ "Report Code" }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.gl_account"
                            name="gl_account"
                            id="gl_account"
                            v-validate=""
                          />
                          <label>{{ "GL Account" }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.gl_desc"
                            name="gl_desc"
                            id="gl_desc"
                            v-validate=""
                          />
                          <label>{{ "GL Desc." }}</label>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- CHARGE IS INCLUSIVE SWITCH -->
                  <div
                    class="col-lg-3 col-xl-2 align-self-center mb-0 mx-0 p-0"
                  >
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        unchecked-value="N"
                        value="Y"
                        v-model="
                          singleCinema.ratecard.frc_is_active_inclusivtax
                        "
                        name="check-button"
                        @change="OnSwitchHandler($event, CinemaIndex)"
                        class="j-checkbox pb-0 mb-0"
                      ></b-form-checkbox>
                      <label class="mb-0 mr-3">{{ $t("inclusivoftax") }}</label>
                    </div>
                  </div>

                  <!-- DAYS -->
                  <div class="col-lg-12 col-xl-12 pl-0 ml-4 mb-2">
                    <div class="row">
                      <div class="mr-1" style="color: black">
                        {{ $t("days") }}:
                      </div>
                      <!--{{ $t("select") }}-->
                      <b-form-checkbox
                        v-for="(
                          weekdaysLoop, weekdaysKey
                        ) in singleCinema.weekDays"
                        :key="weekdaysKey"
                        style="margin: 0px 3px; min-width: 100px"
                        class="j-checkbox mb-1"
                        @change="
                          onChangeWeekdays($event, weekdaysKey, CinemaIndex)
                        "
                        v-model="singleCinema.weekDays[weekdaysKey]"
                      >
                        <div class="text-capitalize">{{ weekdaysKey }}</div>
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-1 d-flex"
                :class="
                  CinemaPriceSettings && CinemaPriceSettings.length > 1
                    ? 'border-left'
                    : ''
                "
              >
                <button
                  v-if="CinemaPriceSettings && CinemaPriceSettings.length > 1"
                  @click.prevent.stop="removeCinemaSettings(CinemaIndex)"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-4 position-relative"
          >
            <button
              @click.prevent.stop="addCinemaSetting()"
              class="btn-transparent add-more-button"
              :disabled="isRoleID"
            >
              <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
            </button>
          </div>

          <section class="mb-2 mt-2 w-100 customization-section-new px-0">
            <div
              class="section-title mb-2 d-flex justify-content-between section-collapse-box"
              v-b-toggle.customizationBlock
              style="padding: 6px; align-items: center"
            >
              <span class="fs">
                {{ $t("add") }} {{ $t("customization") }}
              </span>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse
              id="customizationBlock"
              class="mt-2"
              v-model="sectionCollapse.customizationBlock"
            >
              <div v-if="customizationMap.length > 0">
                <div class="row new-border back mx-0 rounded mb-2">
                  <div class="col-11 pl-0">
                    <div class="col-12 pt-3">
                      <div class="row">
                        <div
                          class="col-lg-6 col-xl-4 align-self-center mb-4"
                          v-for="(
                            customizationSetting, index
                          ) in customizationMap"
                          :key="index"
                        >
                          <div class="dropdown-curve-container pr-28px">
                            <label
                              :class="
                                customizationSetting.selectedCustomization
                                  ? 'shift-up'
                                  : ''
                              "
                              >{{ $tc("customization", 1) }}</label
                            >
                            <multiselect
                              :options="customizations"
                              v-model="
                                customizationSetting.selectedCustomization
                              "
                              :searchable="true"
                              label="item_name"
                              track-by="item_id"
                              placeholder="Customization"
                              @select="onSelectCustomisation($event, index)"
                              @remove="onRemoveCustomisation($event, index)"
                              :allowEmpty="true"
                              :showLabels="false"
                            >
                            </multiselect>
                            <p
                              v-if="
                                submitted &&
                                !customizationSetting.selectedCustomization
                              "
                              class="error_message"
                            >
                              Please Customization.
                            </p>
                          </div>
                        </div>

                        <!-- <div class="col-lg-3 col-xl-4 align-self-center">
                        <div class="d-flex align-items-center mb-4">
                          <span>{{ $t("compulosry") }}</span>
                          <b-form-checkbox
                            class="ml-3"
                            v-model="customizationSetting.is_compulsory"
                            unchecked-value="N"
                            value="Y"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div> -->
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-1 d-flex align-items-center justify-content-center border-left"
                  >
                    <button
                      v-if="index === 0 && false"
                      @click.prevent.stop="addCustomizationSetting($event)"
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                    <button
                      @click.prevent.stop="
                        removeCustomizationSetting($event, index)
                      "
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row w-100 pl-5">
                  <p class="mx-auto text-muted mb-1">Add Customization</p>
                </div>
              </div>
              <div
                class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
              >
                <button
                  @click.prevent.stop="addCustomizationSetting($event)"
                  class="btn-transparent add-more-button"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </b-collapse>
          </section>
        </section>

        <section
          class="col-12 combo-wrapper"
          v-else-if="fnb_item.has_modifiers == 'Y'"
        >
          <div class="row px-0 mt-3" style="gap: 15px">
            <div class="section-title mt-3 mb-4">
              {{ "Modifier" }}
            </div>

            <div class="align-self-center mb-2">
              <div class="dropdown-curve-container">
                <label
                  :class="selectedModifierCategory.length > 0 ? 'shift-up' : ''"
                  style="font-weight: 600"
                  >{{ "Modifier Category" }}</label
                >
                <multiselect
                  :options="modifierCatergories"
                  v-model="selectedModifierCategory"
                  :searchable="true"
                  :multiple="true"
                  label="category_name"
                  track-by="category_id"
                  style="min-width: 210px"
                  @input="onSelectModifierCategories($event, 'select')"
                  @remove="onSelectModifierCategories($event, 'remove')"
                ></multiselect>
                <p
                  v-if="submitted && selectedModifierCategory.length == 0"
                  class="error_message"
                >
                  Please Select Categories.
                </p>
              </div>
            </div>
          </div>

          <div class="row mb-2 border-new back">
            <div
              class="row sec-1 m-2"
              v-for="(singleCinema, CinemaIndex) in CinemaPriceSettings"
              :key="CinemaIndex"
            >
              <div class="col-11">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <!-- SELECT CINEMA -->
                      <div class="col-lg-12 col-xl-3 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              CinemaPriceSettings[CinemaIndex].cinema_id &&
                              String(CinemaPriceSettings[CinemaIndex].cinema_id)
                                .length > 0
                                ? 'shift-up'
                                : ''
                            "
                            style="font-weight: 600"
                            >{{ $tc("cinema", 1) }}</label
                          >
                          <multiselect
                            :options="cinemaListFiltered"
                            v-model="singleCinema.selectedCinemas"
                            :searchable="true"
                            label="cine_name"
                            track-by="cine_id"
                            placeholder=""
                            @input="onDropdownChange($event, CinemaIndex)"
                            :allowEmpty="false"
                            :showLabels="false"
                            :disabled="isRoleID"
                          ></multiselect>
                          <p class="error_message">
                            <span
                              v-if="
                                submitted &&
                                singleCinema.selectedCinema.length == 0
                              "
                            >
                              Please Select Cinema.
                            </span>
                          </p>
                        </div>
                      </div>

                      <!-- SELECT RECIPE -->
                      <div class="col-lg-4 col-xl-2 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              CinemaPriceSettings[CinemaIndex].itemcost_price
                                .item_id &&
                              String(
                                CinemaPriceSettings[CinemaIndex].itemcost_price
                                  .item_id
                              ).length > 0
                                ? 'shift-up'
                                : ''
                            "
                            style="font-weight: 600"
                            >{{ $t("recipeoptional") }}
                          </label>
                          <div
                            class="d-flex justify-content-center align-items-center overFlowHide"
                          >
                            <multiselect
                              v-model="singleCinema.recipe_name"
                              @remove="
                                onRemoveFnbItem($event, CinemaIndex);
                                fnb_item.recipe_id = '';
                                singleCinema.recipe_label = '';
                              "
                              @select="
                                onSelectFnbItem($event, CinemaIndex);
                                fnb_item.recipe_id = $event.recipe_id;
                                singleCinema.recipe_label = $event.recipe_name;
                              "
                              :placeholder="
                                singleCinema.recipe_label &&
                                singleCinema.recipe_label.length > 0
                                  ? singleCinema.recipe_label
                                  : 'Recipe Optional'
                              "
                              :options="recipes"
                              label="recipe_name"
                              track-by="recipe_id"
                              :disabled="
                                role_id == 1 || role_id == 2
                                  ? false
                                  : singleCinema.cinemaFlag
                              "
                              :multiple="false"
                              :showLabels="true"
                              :searchable="true"
                              select-label="Select"
                              deselect-label="Remove"
                              v-b-tooltip.hover
                              :title="$t('fnbitems_tooltip')"
                            ></multiselect>
                          </div>
                          <p class="error_message">
                            <span></span>
                          </p>
                        </div>
                      </div>

                      <!-- ITEM COST PRICE -->
                      <div class="col-lg-4 col-xl-2 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="."
                              type="number"
                              style="text-align: right"
                              v-model="singleCinema.itemcost_price.costprice"
                              name="costprice"
                              id="costprice"
                            />
                            <label>{{ $t("itemcostprice") }}</label>
                          </div>
                          <!--Tooltip :title="$t('itemcostprice_costPrice')" /-->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('costprice')">{{
                            errors.first("costprice")
                          }}</span>
                        </p>
                      </div>

                      <!-- FNB PRICE -->
                      <div class="col-lg-3 col-xl-2 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="."
                              style="text-align: right"
                              v-model="singleCinema.ratecard.frc_amount"
                              v-on:keyup="
                                onChangeRatecardAmount($event, CinemaIndex)
                              "
                              type="number"
                              name="cardamount"
                              id="cardamount"
                              v-validate="{
                                required: 'required',
                                regex: '[0-9]|[0-9]*\\.[0-9]*$',
                              }"
                            />
                            <label>{{ $t("amount") }}</label>
                          </div>
                          <!--Tooltip :title="$t('tooltip')" /-->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('cardamount')">
                            {{ "Enter Valid Amount" }}
                          </span>
                        </p>
                      </div>

                      <!-- CHARGE SETTING NAME -->
                      <div class="col-lg-4 col-xl-3 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              CinemaPriceSettings[CinemaIndex]
                                .selectedChargeSettingName &&
                              String(
                                CinemaPriceSettings[CinemaIndex]
                                  .selectedChargeSettingName
                              ).length > 0
                                ? 'shift-up'
                                : ''
                            "
                          ></label>
                          <multiselect
                            :options="singleCinema.pas_setting_name_list"
                            :searchable="true"
                            :placeholder="
                              singleCinema.selectedChargeSettingName.length > 0
                                ? singleCinema.selectedChargeSettingName
                                : 'Charge'
                            "
                            label="pas_charge_setting_name"
                            track-by="pas_id"
                            @select="
                              onChangeSettingName($event, $event, CinemaIndex)
                            "
                            :allowEmpty="false"
                            :showLabels="false"
                          ></multiselect>
                          <p class="error_message">
                            <span
                              v-if="
                                submitted &&
                                singleCinema.selectedChargeSettingName.length ==
                                  0
                              "
                            >
                              Please Select Charge Setting Name.
                            </span>
                          </p>
                        </div>
                      </div>

                      <div class="col-12">
                        <div
                          class="combo-box row"
                          v-for="(
                            category, categoryIndex
                          ) in singleCinema.modifier_pack"
                          :key="categoryIndex"
                          v-if="singleCinema.modifier_pack.length > 0"
                        >
                          <div class="col-md-2 col-sm-6">
                            <div class="d-flex align-items-center">
                              <div class="input-material">
                                <input
                                  type="text"
                                  disabled
                                  style="text-align: right"
                                  v-model="category.category_name"
                                  name="category_name"
                                  id="category_name"
                                />
                                <label>{{ "Category" }}</label>
                              </div>
                            </div>
                            <div class="checkbox-box mt-2">
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  type="checkbox"
                                  :name="`non_mandatory_${categoryIndex}`"
                                  :id="`non_mandatory_${categoryIndex}`"
                                  class="j-checkbox"
                                  style="padding-bottom: 0px"
                                  v-model="category.non_mandatory_modifier"
                                  unchecked-value="N"
                                  value="Y"
                                >
                                </b-form-checkbox>
                                <label
                                  class="mb-0 mr-3"
                                  :for="`non_mandatory_${categoryIndex}`"
                                  style="white-space: nowrap"
                                  >{{ $t("Non Mandatory") }}</label
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <div class="dropdown-curve-container">
                              <label
                                :class="'shift-up'"
                                style="font-weight: 600"
                                >{{ "Default Item" }}</label
                              >
                              <multiselect
                                :options="
                                  getModifierCategoryItems(
                                    singleCinema,
                                    category,
                                    null
                                  )
                                "
                                v-model="category.default_item"
                                @select="
                                  onSelectDefaultModifierItem(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'select'
                                  )
                                "
                                @remove="
                                  onSelectDefaultModifierItem(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'remove'
                                  )
                                "
                                :searchable="true"
                                :multiple="false"
                                label="rm_name"
                                track-by="rm_id"
                                :customLabel="customLabelRm"
                                :ref="`rm_name_CINE${CinemaIndex}_CAT${categoryIndex}`"
                              >
                                <template slot="option" slot-scope="props">
                                  <span v-if="props.option.alt_rm_name">{{
                                    props.option.alt_rm_name
                                  }}</span>
                                  <span v-if="props.option.alt_rm_name"
                                    >- ({{ props.option.rm_name }})</span
                                  >
                                  <span v-else>{{ props.option.rm_name }}</span>
                                </template>
                                <template slot="tag" slot-scope="props">
                                  <span class="multiselect__tag">
                                    <span v-if="props.option.alt_rm_name">{{
                                      props.option.alt_rm_name
                                    }}</span>
                                    <span v-else>{{
                                      props.option.rm_name
                                    }}</span>
                                  </span>
                                </template>
                              </multiselect>
                              <p class="error_message">
                                <span
                                  v-if="
                                    getModifierCategoryItems(
                                      singleCinema,
                                      category,
                                      null
                                    ).length == 0
                                  "
                                  >No Items For Selected Category</span
                                >
                                <span
                                  v-else-if="
                                    !category.default_item_id && submitted
                                  "
                                  >Please Select Item</span
                                >
                              </p>
                            </div>
                          </div>
                          <div class="col-md-1 col-sm-2">
                            <div class="d-flex align-items-center">
                              <div class="input-material">
                                <input
                                  type="number"
                                  style="text-align: right"
                                  v-model="category.quantity"
                                  name="item_qty"
                                  id="item_qty"
                                />
                                <label>{{ "Qty" }}</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-2 col-sm-2">
                            <div class="dropdown-curve-container">
                              <label
                                :class="'shift-up'"
                                style="font-weight: 600"
                                >{{ "UOM" }}</label
                              >
                              <multiselect
                                :options="category['uomList']"
                                v-model="category.selectedUom"
                                @select="
                                  onSelectModifierUOM(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'select'
                                  )
                                "
                                @remove="
                                  onSelectModifierUOM(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'remove'
                                  )
                                "
                                :searchable="true"
                                :multiple="false"
                                :showLabels="false"
                                label="uom_short_form"
                                track-by="uom_id"
                              ></multiselect>
                              <p class="error_message">
                                <span
                                  v-if="
                                    !category['uomList'].length &&
                                    category['default_item_id']
                                  "
                                  >No UOM For Selected Item</span
                                >
                                <span v-else-if="!category.uom_id && submitted"
                                  >Please Select UOM</span
                                >
                              </p>
                            </div>
                          </div>
                          <div class="col-md-4 col-sm-6">
                            <div class="dropdown-curve-container">
                              <label
                                :class="'shift-up'"
                                style="font-weight: 600"
                                >{{ "Alternate Items" }}</label
                              >
                              <multiselect
                                :options="
                                  getModifierCategoryItems(
                                    singleCinema,
                                    category,
                                    'alternate'
                                  )
                                "
                                v-model="category.alternate_items"
                                :searchable="true"
                                :multiple="true"
                                label="rm_name"
                                track-by="rm_id"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :ref="`alt_rm_name_CINE${CinemaIndex}_CAT${categoryIndex}`"
                              >
                                <!-- <span slot="option" slot-scope="props">
                                  <span>{{ props.option.rm_name }} </span><br />
                                  <span
                                    v-if="
                                      props.option.hasOwnProperty(
                                        '$isDisabled'
                                      ) && props.option['$isDisabled']
                                    "
                                    class="text-truncate"
                                    style="
                                      font-size: 11px !important;
                                      color: red;
                                    "
                                    >{{ "UOM Not Supported" }}
                                  </span>
                                </span> -->
                                <template slot="option" slot-scope="props">
                                  <span v-if="props.option.alt_rm_name">{{
                                    props.option.alt_rm_name
                                  }}</span>
                                  <span v-else>{{ props.option.rm_name }}</span>
                                  <span
                                    v-if="
                                      props.option.hasOwnProperty(
                                        '$isDisabled'
                                      ) && props.option['$isDisabled']
                                    "
                                    class="text-truncate"
                                    style="
                                      font-size: 11px !important;
                                      color: red;
                                    "
                                    >{{ "UOM Not Supported" }}
                                  </span>
                                </template>
                                <template slot="tag" slot-scope="props">
                                  <span class="multiselect__tag">
                                    <span v-if="props.option.alt_rm_name">{{
                                      props.option.alt_rm_name
                                    }}</span>
                                    <span v-else>{{
                                      props.option.rm_name
                                    }}</span>
                                  </span>
                                </template>
                              </multiselect>
                              <p class="error_message"></p>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="singleCinema.modifier_pack.length == 0"
                          class="noCategory"
                        >
                          <span>Please Select Modifier Category</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div
                    class="col-lg-12 col-xl-1 d-flex align-items-center combo-inner-title"
                  >
                    {{ "Validity" }}
                  </div> -->

                  <!-- FROM DATE -->
                  <div class="col-lg-4 col-xl-2 align-self-center my-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="singleCinema.ms_fnb_price.fp_from_date"
                            @click="resetFromDate(CinemaIndex)"
                          >
                            ✖
                          </button>
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="singleCinema.ms_fnb_price.fp_from_date"
                            name="fdate1"
                            id="fdate1"
                            typeable
                            v-validate="'required'"
                            v-b-tooltip.hover
                            :title="$t('fnbpricing_fromdate')"
                          ></Datepicker>
                          <label
                            :class="
                              typeof singleCinema.ms_fnb_price.fp_from_date ===
                              'object'
                                ? 'active'
                                : ''
                            "
                            >From</label
                          >
                        </div>
                      </div>
                      <!--Tooltip :title="$t('fnbpricing_fromdate')" /-->
                    </div>
                    <p
                      v-if="submitted && errors.has('fdate1')"
                      class="error_message"
                    >
                      {{ errors.first("fdate1") }}
                    </p>
                  </div>

                  <!-- TO DATE -->
                  <div class="col-lg-4 col-xl-2 align-self-center my-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="singleCinema.ms_fnb_price.fp_to_date"
                            @click="resetToDate(CinemaIndex)"
                          >
                            ✖
                          </button>
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="singleCinema.ms_fnb_price.fp_to_date"
                            name="tdate1"
                            id="tdate1"
                            typeable
                            v-b-tooltip.hover
                            :title="$t('fnbpricing_todate')"
                          ></Datepicker>
                          <label
                            :class="
                              typeof singleCinema.ms_fnb_price.fp_to_date ===
                              'object'
                                ? 'active'
                                : ''
                            "
                            >To (Optional)</label
                          >
                        </div>
                      </div>
                    </div>
                    <!--p class="text-muted fs-12">({{ $t("optional") }})</p-->
                  </div>

                  <template v-if="showErpColumns">
                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.report_code"
                            name="report_code"
                            id="report_code"
                            v-validate=""
                          />
                          <label>{{ "Report Code" }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.gl_account"
                            name="gl_account"
                            id="gl_account"
                            v-validate=""
                          />
                          <label>{{ "GL Account" }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.gl_desc"
                            name="gl_desc"
                            id="gl_desc"
                            v-validate=""
                          />
                          <label>{{ "GL Desc." }}</label>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- CHARGE IS INCLUSIVE SWITCH -->
                  <div
                    class="col-lg-3 col-xl-2 align-self-center mb-0 mx-0 p-0"
                  >
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        unchecked-value="N"
                        value="Y"
                        v-model="
                          singleCinema.ratecard.frc_is_active_inclusivtax
                        "
                        name="check-button"
                        @change="OnSwitchHandler($event, CinemaIndex)"
                        class="j-checkbox pb-0 mb-0"
                      ></b-form-checkbox>
                      <label class="mb-0 mr-3">{{ $t("inclusivoftax") }}</label>
                    </div>
                  </div>

                  <!-- DAYS -->
                  <div class="col-lg-12 col-xl-12 pl-0 ml-4 mb-2">
                    <div class="row">
                      <div class="mr-1" style="color: black">
                        {{ $t("days") }}:
                      </div>
                      <!--{{ $t("select") }}-->
                      <b-form-checkbox
                        v-for="(
                          weekdaysLoop, weekdaysKey
                        ) in singleCinema.weekDays"
                        :key="weekdaysKey"
                        style="margin: 0px 3px; min-width: 100px"
                        class="j-checkbox mb-1"
                        @change="
                          onChangeWeekdays($event, weekdaysKey, CinemaIndex)
                        "
                        v-model="singleCinema.weekDays[weekdaysKey]"
                      >
                        <div class="text-capitalize">{{ weekdaysKey }}</div>
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-1 d-flex"
                :class="
                  CinemaPriceSettings && CinemaPriceSettings.length > 1
                    ? 'border-left'
                    : ''
                "
              >
                <button
                  v-if="CinemaPriceSettings && CinemaPriceSettings.length > 1"
                  @click.prevent.stop="removeCinemaSettings(CinemaIndex)"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-4 position-relative"
          >
            <button
              @click.prevent.stop="addCinemaSetting()"
              class="btn-transparent add-more-button"
              :disabled="isRoleID"
            >
              <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
            </button>
          </div>

          <section class="mb-2 mt-2 w-100 customization-section-new px-0">
            <div
              class="section-title mb-2 d-flex justify-content-between section-collapse-box"
              v-b-toggle.customizationBlock
              style="padding: 6px; align-items: center"
            >
              <span class="fs">
                {{ $t("add") }} {{ $t("customization") }}
              </span>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse
              id="customizationBlock"
              class="mt-2"
              v-model="sectionCollapse.customizationBlock"
            >
              <div v-if="customizationMap.length > 0">
                <div class="row new-border back mx-0 rounded mb-2">
                  <div class="col-11 pl-0">
                    <div class="col-12 pt-3">
                      <div class="row">
                        <div
                          class="col-lg-6 col-xl-4 align-self-center mb-4"
                          v-for="(
                            customizationSetting, index
                          ) in customizationMap"
                          :key="index"
                        >
                          <div class="dropdown-curve-container pr-28px">
                            <label
                              :class="
                                customizationSetting.selectedCustomization
                                  ? 'shift-up'
                                  : ''
                              "
                              >{{ $tc("customization", 1) }}</label
                            >
                            <multiselect
                              :options="customizations"
                              v-model="
                                customizationSetting.selectedCustomization
                              "
                              :searchable="true"
                              label="item_name"
                              track-by="item_id"
                              placeholder="Customization"
                              @select="onSelectCustomisation($event, index)"
                              @remove="onRemoveCustomisation($event, index)"
                              :allowEmpty="true"
                              :showLabels="false"
                            >
                            </multiselect>
                            <p
                              v-if="
                                submitted &&
                                !customizationSetting.selectedCustomization
                              "
                              class="error_message"
                            >
                              Please Customization.
                            </p>
                          </div>
                        </div>

                        <!-- <div class="col-lg-3 col-xl-4 align-self-center">
                        <div class="d-flex align-items-center mb-4">
                          <span>{{ $t("compulosry") }}</span>
                          <b-form-checkbox
                            class="ml-3"
                            v-model="customizationSetting.is_compulsory"
                            unchecked-value="N"
                            value="Y"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div> -->
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-1 d-flex align-items-center justify-content-center border-left"
                  >
                    <button
                      v-if="index === 0 && false"
                      @click.prevent.stop="addCustomizationSetting($event)"
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                    <button
                      @click.prevent.stop="
                        removeCustomizationSetting($event, index)
                      "
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row w-100 pl-5">
                  <p class="mx-auto text-muted mb-1">Add Customization</p>
                </div>
              </div>
              <div
                class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
              >
                <button
                  @click.prevent.stop="addCustomizationSetting($event)"
                  class="btn-transparent add-more-button"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </b-collapse>
          </section>
        </section>

        <section v-else class="col-12 normal-fnb-item px-0">
          <div class="row">
            <div class="col-md-12 px-0">
              <div class="section-title mt-3 mb-2">
                {{ $tc("price", 1) }} {{ $tc("details", 2) }}
              </div>
            </div>

            <div class="col-md-12 mb-2 border-new back">
              <div
                class="row sec-1 mt-2 mx-1"
                v-for="(singleCinema, CinemaIndex) in CinemaPriceSettings"
                :key="CinemaIndex"
              >
                <div class="col-11">
                  <div class="row">
                    <!-- SELECT CINEMA -->
                    <div class="col-lg-4 col-xl-3 align-self-center mb-3">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            CinemaPriceSettings[CinemaIndex].cinema_id &&
                            String(CinemaPriceSettings[CinemaIndex].cinema_id)
                              .length > 0
                              ? 'shift-up'
                              : ''
                          "
                          style="font-weight: 600"
                          >{{ $tc("cinema", 1) }}</label
                        >
                        <!--<label :class="singleCinema.selectedCinemas.length > 0 ? 'shift-up' : '' ">-->
                        <!--  Select Cinemas-->
                        <!--</label>-->
                        <multiselect
                          :options="cinemaListFiltered"
                          v-model="singleCinema.selectedCinemas"
                          :searchable="true"
                          label="cine_name"
                          track-by="cine_id"
                          placeholder=""
                          @input="onDropdownChange($event, CinemaIndex)"
                          :allowEmpty="false"
                          :showLabels="false"
                          :disabled="isRoleID"
                        ></multiselect>

                        <!-- <b-dropdown
                  :disabled="isRoleID"
                  :text="singleCinema.selectedCinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(dropdownItem,dropdownIndex) in cinemaListCopy"
                    :key="dropdownIndex"
                    href="#"
                    @click="onDropdownChange($event, dropdownItem,CinemaIndex)"
                  >{{ dropdownItem.cine_name }}</b-dropdown-item>
                </b-dropdown>-->
                        <p
                          v-if="
                            submitted && singleCinema.selectedCinema.length == 0
                          "
                          class="error_message"
                        >
                          Please Select Cinema.
                        </p>
                      </div>
                    </div>

                    <!-- SELECT RECIPE -->
                    <div class="col-lg-4 col-xl-3 align-self-center mb-3">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            CinemaPriceSettings[CinemaIndex].itemcost_price
                              .item_id &&
                            String(
                              CinemaPriceSettings[CinemaIndex].itemcost_price
                                .item_id
                            ).length > 0
                              ? 'shift-up'
                              : ''
                          "
                          style="font-weight: 600"
                          >{{ $t("recipeoptional") }}
                        </label>
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <!-- <b-dropdown
                    :text="singleCinema.recipe_label"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(recipe,recipesIndex) in recipes"
                      :key="recipesIndex"
                      href="#"
                      @click="onSelectFnbItem(recipe,CinemaIndex);fnb_item.recipe_id=recipe.recipe_id;singleCinema.recipe_label=recipe.recipe_name"
                    >{{ recipe.recipe_name }}</b-dropdown-item>
                  </b-dropdown>
                 <label
                 :class="CinemaPriceSettings[CinemaIndex].itemcost_price.item_id &&  String(CinemaPriceSettings[CinemaIndex].itemcost_price.item_id).length> 0 ? 'shift-up' : '' "
                {{ $tc(recipeoptional) }}</label>-->
                          <multiselect
                            v-model="singleCinema.recipe_name"
                            @remove="
                              onRemoveFnbItem($event, CinemaIndex);
                              fnb_item.recipe_id = '';
                              singleCinema.recipe_label = '';
                            "
                            @select="
                              onSelectFnbItem($event, CinemaIndex);
                              fnb_item.recipe_id = $event.recipe_id;
                              singleCinema.recipe_label = $event.recipe_name;
                            "
                            :placeholder="
                              singleCinema.recipe_label &&
                              singleCinema.recipe_label.length > 0
                                ? singleCinema.recipe_label
                                : 'Recipe Optional'
                            "
                            :options="recipes"
                            label="recipe_name"
                            track-by="recipe_id"
                            :disabled="
                              role_id == 1 || role_id == 2
                                ? false
                                : singleCinema.cinemaFlag
                            "
                            :multiple="false"
                            :showLabels="true"
                            :searchable="true"
                            select-label="Select"
                            deselect-label="Remove"
                            v-b-tooltip.hover
                            :title="$t('fnbitems_tooltip')"
                          ></multiselect>
                          <!--Tooltip :title="$t('fnbitems_tooltip')" /-->
                        </div>
                        <p class="error_message d-none">
                          <!-- <span v-if="submitted && recipe_label.length == 0">Please Select Recipe.</span> -->
                          <span></span>
                        </p>
                      </div>
                    </div>

                    <!-- ITEM COST PRICE -->
                    <div class="col-lg-4 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center mb-3">
                        <div class="input-material">
                          <input
                            placeholder="."
                            type="number"
                            style="text-align: right"
                            v-model="singleCinema.itemcost_price.costprice"
                            name="costprice"
                            id="costprice"
                          />
                          <label>{{ $t("itemcostprice") }}</label>
                        </div>
                        <!--Tooltip :title="$t('itemcostprice_costPrice')" /-->
                      </div>
                    </div>

                    <!-- FNB PRICE -->
                    <div class="col-lg-3 col-xl-2 align-self-center mb-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            placeholder="."
                            style="text-align: right"
                            v-model="singleCinema.ratecard.frc_amount"
                            v-on:keyup="
                              onChangeRatecardAmount($event, CinemaIndex)
                            "
                            type="number"
                            name="cardamount"
                            id="cardamount"
                            v-validate="{
                              required: 'required',
                              regex: '[0-9]|[0-9]*\\.[0-9]*$',
                            }"
                          />
                          <label>{{ $t("amount") }}</label>
                        </div>
                        <!--Tooltip :title="$t('tooltip')" /-->
                      </div>
                    </div>

                    <!-- CHARGE IS INCLUSIVE SWITCH -->
                    <div class="col-lg-3 col-xl-2 align-self-center mb-3">
                      <div class="d-flex align-items-center">
                        <b-form-checkbox
                          unchecked-value="N"
                          value="Y"
                          v-model="
                            singleCinema.ratecard.frc_is_active_inclusivtax
                          "
                          name="check-button"
                          @change="OnSwitchHandler($event, CinemaIndex)"
                          class="j-checkbox pb-0 mb-0"
                        ></b-form-checkbox>
                        <label class="mb-0 mr-3">{{
                          $t("inclusivoftax")
                        }}</label>
                      </div>
                    </div>

                    <!-- FROM DATE -->
                    <div class="col-lg-4 col-xl-3 align-self-center mb-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <div class="add-datepicker">
                            <button
                              class="btn-clearDate"
                              v-if="singleCinema.ms_fnb_price.fp_from_date"
                              @click="resetFromDate(CinemaIndex)"
                            >
                              ✖
                            </button>
                            <Datepicker
                              :monday-first="true"
                              ref="programaticOpen"
                              v-model="singleCinema.ms_fnb_price.fp_from_date"
                              name="fdate1"
                              id="fdate1"
                              typeable
                              v-validate="'required'"
                              v-b-tooltip.hover
                              :title="$t('fnbpricing_fromdate')"
                            ></Datepicker>
                            <label
                              :class="
                                typeof singleCinema.ms_fnb_price
                                  .fp_from_date === 'object'
                                  ? 'active'
                                  : ''
                              "
                              >From</label
                            >
                          </div>
                        </div>
                        <!--Tooltip :title="$t('fnbpricing_fromdate')" /-->
                      </div>
                      <p
                        v-if="submitted && errors.has('fdate1')"
                        class="error_message"
                      >
                        {{ errors.first("fdate1") }}
                      </p>
                    </div>

                    <!-- TO DATE -->
                    <div class="col-lg-4 col-xl-3 align-self-center mb-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <div class="add-datepicker">
                            <button
                              class="btn-clearDate"
                              v-if="singleCinema.ms_fnb_price.fp_to_date"
                              @click="resetToDate(CinemaIndex)"
                            >
                              ✖
                            </button>
                            <Datepicker
                              :monday-first="true"
                              ref="programaticOpen"
                              v-model="singleCinema.ms_fnb_price.fp_to_date"
                              name="tdate1"
                              id="tdate1"
                              typeable
                              v-b-tooltip.hover
                              :title="$t('fnbpricing_todate')"
                            ></Datepicker>
                            <label
                              :class="
                                typeof singleCinema.ms_fnb_price.fp_to_date ===
                                'object'
                                  ? 'active'
                                  : ''
                              "
                              >To (Optional)</label
                            >
                          </div>
                        </div>
                        <!--Tooltip :title="$t('fnbpricing_todate')" /-->
                      </div>
                      <!--p class="text-muted fs-12">({{ $t("optional") }})</p-->
                    </div>

                    <!-- CHARGE SETTING NAME -->
                    <div class="col-lg-4 col-xl-3 align-self-center mb-3">
                      <div class="dropdown-curve-container pr-28px">
                        <!-- <label
                  :class="singleCinema.selectedChargeSettingName.length > 0 ? 'shift-up' : '' "
                >{{ $tc('chargesettingname', 1) }}</label>-->
                        <!-- <b-dropdown
                  :text="singleCinema.selectedChargeSettingName"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(dropdownItem,dropdownIndex) in singleCinema.pas_setting_name_list"
                    :key="dropdownIndex"
                    href="#"
                    @click="onChangeSettingName($event, dropdownItem,CinemaIndex)"
                  >{{ dropdownItem.pas_charge_setting_name }}</b-dropdown-item>
                </b-dropdown>-->
                        <label
                          :class="
                            CinemaPriceSettings[CinemaIndex]
                              .selectedChargeSettingName &&
                            String(
                              CinemaPriceSettings[CinemaIndex]
                                .selectedChargeSettingName
                            ).length > 0
                              ? 'shift-up'
                              : ''
                          "
                        ></label>
                        <multiselect
                          :options="singleCinema.pas_setting_name_list"
                          :searchable="true"
                          :placeholder="
                            singleCinema.selectedChargeSettingName.length > 0
                              ? singleCinema.selectedChargeSettingName
                              : 'Charge'
                          "
                          label="pas_charge_setting_name"
                          track-by="pas_id"
                          @select="
                            onChangeSettingName($event, $event, CinemaIndex)
                          "
                          :allowEmpty="false"
                          :showLabels="false"
                        ></multiselect>
                        <p
                          v-if="
                            submitted &&
                            singleCinema.selectedChargeSettingName.length == 0
                          "
                          class="error_message"
                        >
                          Please Select Charge Setting Name.
                        </p>
                      </div>
                    </div>

                    <template v-if="showErpColumns">
                      <div class="col-lg-2 col-xl-2 align-self-center">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              style="text-align: right"
                              placeholder="."
                              type="text"
                              v-model="singleCinema.report_code"
                              name="report_code"
                              id="report_code"
                              v-validate=""
                            />
                            <label>{{ "Report Code" }}</label>
                          </div>
                        </div>
                        <p class="error_message"></p>
                      </div>

                      <div class="col-lg-2 col-xl-2 align-self-center">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              style="text-align: right"
                              placeholder="."
                              type="text"
                              v-model="singleCinema.gl_account"
                              name="gl_account"
                              id="gl_account"
                              v-validate=""
                            />
                            <label>{{ "GL Account" }}</label>
                          </div>
                        </div>
                        <p class="error_message"></p>
                      </div>

                      <div class="col-lg-2 col-xl-2 align-self-center">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              style="text-align: right"
                              placeholder="."
                              type="text"
                              v-model="singleCinema.gl_desc"
                              name="gl_desc"
                              id="gl_desc"
                              v-validate=""
                            />
                            <label>{{ "GL Desc." }}</label>
                          </div>
                        </div>
                        <p class="error_message"></p>
                      </div>
                    </template>

                    <!-- DAYS -->
                    <div class="row ml-4 mb-2">
                      <div class="col-lg-12 col-xl-12 pl-0">
                        <div class="row">
                          <div class="mr-1" style="color: black">
                            {{ $t("days") }}:
                          </div>
                          <!--{{ $t("select") }}-->
                          <b-form-checkbox
                            v-for="(
                              weekdaysLoop, weekdaysKey
                            ) in singleCinema.weekDays"
                            :key="weekdaysKey"
                            style="margin: 0px 3px; min-width: 100px"
                            class="j-checkbox mb-1"
                            @change="
                              onChangeWeekdays($event, weekdaysKey, CinemaIndex)
                            "
                            v-model="singleCinema.weekDays[weekdaysKey]"
                          >
                            <div class="text-capitalize">{{ weekdaysKey }}</div>
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                    <!-- CHARGE SETTINGS -->
                    <div class="col-md-12 col-xl-12 col-lg-12">
                      <div class="col-12">
                        <div class="row">
                          <!-- IMAGE DIMENSION -->
                          <table
                            class="col-xl-7"
                            v-if="
                              singleCinema &&
                              singleCinema.cinemaChargesList.length > 0
                            "
                          >
                            <tr
                              v-for="(
                                cinemaCharge, cinemaChargesListIndex
                              ) in singleCinema.cinemaChargesList"
                              :key="cinemaChargesListIndex"
                              class="main_border_add"
                            >
                              <td
                                style="
                                  padding: 4px 10px;
                                  color: black;
                                  font-weight: bold;
                                "
                              >
                                {{ cinemaCharge.ct_name }}
                              </td>

                              <td
                                style="
                                  padding: 4px 10px;
                                  color: black;
                                  font-weight: bold;
                                  text-align: right;
                                "
                              >
                                {{ cinemaCharge.pas_charge_value
                                }}{{
                                  cinemaCharge.pas_is_percentage == "Y"
                                    ? "%"
                                    : ""
                                }}
                              </td>

                              <td
                                style="
                                  padding: 4px 10px;
                                  color: black;
                                  font-weight: bold;
                                  text-align: right;
                                "
                              >
                                {{
                                  cinemaCharge.cinemacharges
                                    ? parseFloat(
                                        cinemaCharge.cinemacharges || 0
                                      ).toFixed(4)
                                    : 0
                                }}
                              </td>
                            </tr>

                            <tr class="main_border_add">
                              <td style="padding: 4px 10px">
                                <span class="font-weight-bold"
                                  >Net Amount:</span
                                >
                                <span style="color: black; font-weight: bold"
                                  >{{ currencyData.curr_code }}
                                  {{
                                    parseFloat(
                                      singleCinema.ratecard.frc_net_amount
                                    ).toFixed(2)
                                  }}
                                </span>
                              </td>

                              <td style="padding: 4px 10px">
                                <span class="font-weight-bold"
                                  >Gross Total:</span
                                >
                                <span style="color: black; font-weight: bold"
                                  >{{ currencyData.curr_code }}
                                  {{
                                    parseFloat(
                                      singleCinema.ratecard.frc_total_amount
                                    ).toFixed(2)
                                  }}</span
                                >
                              </td>

                              <td style="padding: 4px 10px">
                                <span class="font-weight-bold"
                                  >Food Cost %:</span
                                >
                                <span
                                  v-if="singleCinema.ratecard.frc_total_amount"
                                  style="color: black; font-weight: bold"
                                >
                                  {{
                                    +parseFloat(
                                      (
                                        singleCinema.itemcost_price.costprice /
                                        singleCinema.ratecard.frc_total_amount
                                      ).toFixed(4) * 100
                                    ).toFixed(4)
                                  }}%
                                </span>
                              </td>
                            </tr>
                          </table>

                          <div class="col-md-5 mb-4" v-if="false">
                            <div class="d-flex align-items-center">
                              <div class="input-material">
                                <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                                <label>{{ cinemaCharge.ct_name }}</label>
                              </div>
                            </div>
                            <!-- <p class="error_msg">Invalid Entry</p> -->
                          </div>
                          <div class="col-md-7" v-if="false">
                            <div class="row">
                              <div class="col-md-5">
                                <div
                                  class="d-flex justify-content-center align-items-center p-3"
                                >
                                  <label
                                    >{{ cinemaCharge.pas_charge_value
                                    }}{{
                                      cinemaCharge.pas_is_percentage == "Y"
                                        ? "%"
                                        : ""
                                    }}</label
                                  >
                                </div>
                              </div>
                              <div class="col-md-5">
                                <div
                                  class="d-flex justify-content-center align-items-center p-3"
                                >
                                  <label>{{
                                    cinemaCharge.cinemacharges
                                      ? parseFloat(
                                          cinemaCharge.cinemacharges || 0
                                        ).toFixed(4)
                                      : 0
                                  }}</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12" v-if="false">
                        <div class="text-right">
                          <div>
                            <span class="font-weight-bold">Net Amount:</span>
                            <span
                              >{{ currencyData.curr_code }}
                              {{
                                parseFloat(
                                  singleCinema.ratecard.frc_net_amount
                                ).toFixed(MIN_FRACTION_DIGITS)
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="false">
                        <div class="text-right">
                          <div>
                            <span class="font-weight-bold">Gross Total:</span>
                            <span
                              >{{ currencyData.curr_code }}
                              {{
                                singleCinema.ratecard.frc_total_amount.toFixed(
                                  2
                                )
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="false">
                        <div class="text-right">
                          <div>
                            <span class="font-weight-bold">Food Cost %:</span>
                            <span v-if="singleCinema.ratecard.frc_total_amount"
                              >{{
                                +parseFloat(
                                  (
                                    singleCinema.itemcost_price.costprice /
                                    singleCinema.ratecard.frc_total_amount
                                  ).toFixed(4) * 100
                                ).toFixed(4)
                              }}%</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!---Col 1 Starts Here---->
                <div
                  class="col-1 d-flex"
                  :class="
                    CinemaPriceSettings && CinemaPriceSettings.length > 1
                      ? 'border-left'
                      : ''
                  "
                >
                  <button
                    v-if="CinemaPriceSettings && CinemaPriceSettings.length > 1"
                    @click.prevent.stop="removeCinemaSettings(CinemaIndex)"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>

              <div
                class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-4 position-relative"
              >
                <button
                  @click.prevent.stop="addCinemaSetting()"
                  class="btn-transparent add-more-button"
                  :disabled="isRoleID"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>

            <div class="col-12 mb-2 px-0">
              <multiselect
                v-model="fnb_item.selected_alternate_items"
                track-by="item_code"
                label="item_name"
                :options="alternate_items_list"
                :multiple="true"
                placeholder="Alternate Items"
                :showLabels="false"
              ></multiselect>
            </div>

            <section class="mb-2 mt-2 w-100 customization-section-new px-0">
              <div
                class="section-title mb-2 d-flex justify-content-between section-collapse-box"
                v-b-toggle.customizationBlock
                style="padding: 6px; align-items: center"
              >
                <span class="fs">
                  {{ $t("add") }} {{ $t("customization") }}
                </span>
                <button type="button" class="btn-transparent chevron">
                  <img
                    src="@/assets/img/icons/primary/chevron-down.svg"
                    height="24"
                    width="24"
                  />
                </button>
              </div>
              <b-collapse
                id="customizationBlock"
                class="mt-2"
                v-model="sectionCollapse.customizationBlock"
              >
                <div v-if="customizationMap.length > 0">
                  <div class="row new-border back mx-0 rounded mb-2">
                    <div class="col-11 pl-0">
                      <div class="col-12 pt-3">
                        <div class="row">
                          <div
                            class="col-lg-6 col-xl-4 align-self-center mb-4"
                            v-for="(
                              customizationSetting, index
                            ) in customizationMap"
                            :key="index"
                          >
                            <div class="dropdown-curve-container pr-28px">
                              <label
                                :class="
                                  customizationSetting.selectedCustomization
                                    ? 'shift-up'
                                    : ''
                                "
                                >{{ $tc("customization", 1) }}</label
                              >
                              <multiselect
                                :options="customizations"
                                v-model="
                                  customizationSetting.selectedCustomization
                                "
                                :searchable="true"
                                label="item_name"
                                track-by="item_id"
                                placeholder="Customization"
                                @select="onSelectCustomisation($event, index)"
                                @remove="onRemoveCustomisation($event, index)"
                                :allowEmpty="true"
                                :showLabels="false"
                              >
                              </multiselect>
                              <p
                                v-if="
                                  submitted &&
                                  !customizationSetting.selectedCustomization
                                "
                                class="error_message"
                              >
                                Please Customization.
                              </p>
                            </div>
                          </div>

                          <!-- <div class="col-lg-3 col-xl-4 align-self-center">
                        <div class="d-flex align-items-center mb-4">
                          <span>{{ $t("compulosry") }}</span>
                          <b-form-checkbox
                            class="ml-3"
                            v-model="customizationSetting.is_compulsory"
                            unchecked-value="N"
                            value="Y"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div> -->
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-1 d-flex align-items-center justify-content-center border-left"
                    >
                      <button
                        v-if="index === 0 && false"
                        @click.prevent.stop="addCustomizationSetting($event)"
                        class="btn-transparent"
                      >
                        <img
                          src="@/assets/img/icons/plus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                      <button
                        @click.prevent.stop="
                          removeCustomizationSetting($event, index)
                        "
                        class="btn-transparent"
                      >
                        <img
                          src="@/assets/img/icons/minus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row w-100 pl-5">
                    <p class="mx-auto text-muted mb-1">Add Customization</p>
                  </div>
                </div>
                <div
                  class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                >
                  <button
                    @click.prevent.stop="addCustomizationSetting($event)"
                    class="btn-transparent add-more-button"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </b-collapse>
            </section>
          </div>
        </section>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button class="btn-blue">
            {{ $t("Save As Draft") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onResetForm()"
            class="btn-black"
          >
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="fnb-items">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>

    <!-- MOVIE POSTER IMAGE MODAL -->
    <b-modal
      size="lg"
      hide-footer
      ref="preview-modal"
      id="selected-image-preview-modal"
      title="FNB Image"
    >
      <img :src="_GetImagePath(fnb_item.item_image_url)" class="img-fluid" />
    </b-modal>

    <b-modal
      size="sm"
      hide-footer
      hide-header
      centered
      no-fade
      ref="manualSelectCategory"
      id="manualSelectCategory"
      title=""
    >
      <div class="text-center fs-16 font-weight-bold">Categories</div>
      <b-list-group style="height: 380px; overflow-x: auto">
        <b-list-group-item
          v-for="(category, categoryIndex) in ms_food_categories"
          :key="categoryIndex"
          @click="onSelectManualCategory(category)"
          >{{ category.fc_category }}</b-list-group-item
        >
      </b-list-group>
    </b-modal>

    <!-- Image Upload Modal -->
    <!-- <b-modal id="imagecropper" hide-header hide-footer>
      <label class="h4 mt-2 mb-4 text-center">Crop Image</label>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :aspect-ratio="197 / 295"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
    </b-modal>-->
    <!-- 129*192 -->
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import CinemasService from "@/services/CinemasService";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import ImageGallery from "../../ImageGallery/imageGalleryModal";
import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
import { mapGetters } from "vuex";
import MovieService from "@/services/MovieService";
import _ from "lodash";

export default {
  components: { VueCropper, ImageGallery },
  data() {
    return {
      UomList: [],
      role_id: null,
      selectedComboCategory: [],
      selectedModifierCategory: [],
      modifierCatergories: [],
      alternate_items_list: [],
      set_width: null,
      set_height: null,
      showModal: false,
      ms_food_categoriesCopy: [],
      searchFoodCategories: "",
      isRoleID: true,
      btenable: false,
      imgSrc: "",
      cropImg: "",
      filename: "",
      indexofthubmnail: "",
      loader: this.$loading,
      submitted: false,
      fnb_item: {
        fc_id: "",
        item_code: "TempCode",
        item_name: "",
        report_code: "",
        gl_account: "",
        gl_desc: "",
        alternate_lang_item_name: "",
        item_description: "",
        item_age_restriction: "",
        recipe_id: "",
        fi_order: null,
        customization_common_id: null,
        is_sundry: "N",
        is_combo: "N",
        is_premier_item: "N",
        ready_to_serve: "N",
        is_non_sellable_product: "N",
        item_is_veg: true,
        item_is_recipe: "",
        item_image_url: "",
        includes_egg: false,
        is_package_item: false,
        item_is_active: true,
        selected_alternate_items: [],
        selected_customizations: [],
      },
      ms_food_categories: [],
      BaseURL: "",
      recipes: [],
      currencyData: [],
      recipe_label: "",
      fc_parent_label: "",
      cinemaList: [],
      cinemaListCopy: [],

      customizations: [],
      customizationsCopy: [],
      searchCustomization: "",
      customization_name: "",

      CinemaPriceSettings: [
        {
          selectedCinema: "",
          selectedCinemas: [],
          cinema_id: null,
          recipe_label: "",
          combo_pack: [],
          modifier_pack: [],
          fnb_item_array: [],
          //ITEM COST PRICE
          itemcost_price: {
            cinema_id: "",
            v_id: "",
            item_id: "",
            costprice: "",
            fp_is_active: true,
          },
          report_code: "",
          gl_account: "",
          gl_desc: "",
          //RATE CARD

          selectedCinema: "",
          ratecard: {
            cinema_id: null,
            frc_name: "",
            frc_amount: "",
            currency_id: null,
            frc_is_active_inclusivtax: "Y",
            frc_net_amount: 0,
            frc_total_amount: 0,
          },
          selectedChargeSettingName: "",
          pas_setting_name_list: [],
          cinemaChargesList: [],
          //FNB Pricing
          ms_fnb_price: {
            cinema_id: "",
            item_id: "",
            currency_id: "",
            fnb_rate_card_id: "",
            fp_amount: "",
            fp_total_amount: "",
            fp_from_date: new Date(),
            fp_to_date: "",
            fp_is_active: true,
          },
          weekDays: {
            AllDays: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            sunday: true,
          },
        },
      ],
      Languages: [],
      ContentLanguages: [],
      activeClass: 0,
      FnbItemContent: [],
      notempty: [false, false, false, false, false, false],
      customizationMap: [],
      sectionCollapse: {
        customizationBlock: false,
      },
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let role_id = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }
    this.getGlobalOptions();
    // this.getCurrencyCode();
  },
  computed: {
    showErpColumns() {
      return this.$store.getters.SHOW_ERP_GL_FIELDS == "Y" ? true : false;
    },
    qfx_tax_structure() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.qfx_tax_structure);
    },
    mif_tax_calculation() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.mif_tax_calculation);
    },
    fractionDigits() {
      let fracDigit = 3;
      if (this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis_combo)) {
        fracDigit = 2;
      } else {
        fracDigit = 3;
      }
      return fracDigit;
    },
    cinemaListFiltered() {
      let cinemaArray = this.cinemaListCopy;

      cinemaArray = this.cinemaListCopy.filter(
        (x) => !this.CinemaPriceSettings.some((y) => y.cinema_id == x.cine_id)
      );

      return cinemaArray;
    },
    list() {
      return this.CinemaPriceSettings[index].cinemaChargesList;
    },
    ...mapGetters(["finalImagePath"]),
  },
  created() {
    this.getMovieContentLangauge();
  },
  mounted() {
    this.getRecipeList();
    this.getFoodCategoiresList();
    this.getModifierCategories();
    this.getCustomizationList();
    this.getAlternateItems();
  },
  watch: {
    finalImagePath(newval) {
      this.fnb_item.item_image_url = newval;
    },
  },
  methods: {
    onAddManualCategory() {
      this.$bvModal.show("manualSelectCategory");
    },
    onSelectManualCategory(category) {
      this.selectedComboCategory.push(category);
      this.onSelectComboCategories(category, "forceAdd");
      this.$bvModal.hide("manualSelectCategory");
    },
    removeElement: function (element, refId) {
      this.$refs[refId].removeElement(element);
    },
    customLabelRm(e) {
      return `${e.alt_rm_name ? e.alt_rm_name : e.rm_name}`;
    },
    onChangeIsVeg(event) {
      console.log("onChangeIsVeg", event);
      if (!event) {
        this.fnb_item.includes_egg = false;
      }
    },
    onClickCombo(event) {
      if (event == "Y") {
        this.fnb_item.recipe_id = null;
        this.fnb_item.is_combo = event;
        this.fnb_item.has_modifiers = "N";
        this.fnb_item.item_is_recipe = "";
        this.fnb_item.selected_alternate_items = [];
        this.fnb_item.selected_customizations = [];

        this.CinemaPriceSettings.forEach((x, index) => {
          if (x.cinema_id) {
            this.getComboCinemaList(x.cinema_id, index);
          }
        });
      }
      // this.resetCinemaPriceSettings();
    },
    onClickModifier(event) {
      if (event == "Y") {
        this.fnb_item.recipe_id = null;
        this.fnb_item.is_combo = "N";
        this.fnb_item.has_modifiers = "Y";
        this.fnb_item.item_is_recipe = "";
        this.fnb_item.selected_alternate_items = [];
        this.fnb_item.selected_customizations = [];
        // this.CinemaPriceSettings.forEach((x, index) => {
        //   if (x.cinema_id) {
        //     this.getComboCinemaList(x.cinema_id, index);
        //   }
        // });
        if (this.UomList.length == 0) {
          this.getUomList();
        }
      }
      // this.resetCinemaPriceSettings();
    },
    resetCinemaPriceSettings() {
      let CinemaPriceSettings = [
        {
          selectedCinema: "",
          selectedCinemas: [],
          cinema_id: null,
          recipe_label: "",
          combo_pack: [],
          modifier_pack: [],
          fnb_item_array: [],
          //ITEM COST PRICE
          itemcost_price: {
            cinema_id: "",
            v_id: "",
            item_id: "",
            costprice: "",
            fp_is_active: true,
          },
          report_code: "",
          gl_account: "",
          gl_desc: "",
          //RATE CARD

          selectedCinema: "",
          ratecard: {
            cinema_id: null,
            frc_name: "",
            frc_amount: "",
            currency_id: null,
            frc_is_active_inclusivtax: "Y",
            frc_net_amount: 0,
            frc_total_amount: 0,
          },
          selectedChargeSettingName: "",
          pas_setting_name_list: [],
          cinemaChargesList: [],
          //FNB Pricing
          ms_fnb_price: {
            cinema_id: "",
            item_id: "",
            currency_id: "",
            fnb_rate_card_id: "",
            fp_amount: "",
            fp_total_amount: "",
            fp_from_date: new Date(),
            fp_to_date: "",
            fp_is_active: true,
          },
          weekDays: {
            AllDays: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            sunday: true,
          },
        },
      ];
      this.CinemaPriceSettings = _.cloneDeep(CinemaPriceSettings);
    },
    onSelectDefaultItem(event, cinemaIndex, categoryIndex, type) {
      if (type == "select") {
        this.CinemaPriceSettings[cinemaIndex].combo_pack[
          categoryIndex
        ].default_item = event;
        this.CinemaPriceSettings[cinemaIndex].combo_pack[
          categoryIndex
        ].default_item_id = event.item_id;
        this.CinemaPriceSettings[cinemaIndex].combo_pack[
          categoryIndex
        ].default_item_name = event.item_name;
        this.CinemaPriceSettings[cinemaIndex].combo_pack[
          categoryIndex
        ].alternate_items = [];
      } else if (type == "remove") {
        this.CinemaPriceSettings[cinemaIndex].combo_pack[
          categoryIndex
        ].default_item = "";
        this.CinemaPriceSettings[cinemaIndex].combo_pack[
          categoryIndex
        ].default_item_id = null;
        this.CinemaPriceSettings[cinemaIndex].combo_pack[
          categoryIndex
        ].default_item_name = "";
      }
    },
    onSelectDefaultModifierItem(event, cinemaIndex, categoryIndex, type) {
      if (type == "select") {
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].default_item = event;
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].default_item_id = event.rm_id;
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].default_item_name = event.rm_name;
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].alternate_items = [];
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].selectedUom = "";
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].uom_id = null;
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].uomList = this.getFilteredUOM(event["uom_id_threshold"]);
      } else if (type == "remove") {
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].default_item = "";
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].default_item_id = null;
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].default_item_name = "";
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].selectedUom = "";
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].uom_id = null;
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].uomList = [];
      }
    },
    getFilteredUOM(uom_id) {
      let UOMArray = [];
      let checkUOM = [...this.UomList].filter((x) => x.uom_id == uom_id);
      console.log("checkUOM", checkUOM);
      if (checkUOM && checkUOM.length) {
        UOMArray = [...UOMArray, ...checkUOM];
        console.log("UOMArray 1", UOMArray);
        if (
          checkUOM[0].hasOwnProperty("uom_parent_id") &&
          checkUOM[0].uom_parent_id
        ) {
          let tempArr = [...this.UomList].filter(
            (x) => x.uom_id == checkUOM[0].uom_parent_id
          );
          if (tempArr && tempArr.length) {
            UOMArray = [...UOMArray, ...tempArr];
            console.log("UOMArray 2", UOMArray);
          }
        } else {
          let tempArr = [...this.UomList].filter(
            (x) => x.uom_parent_id == checkUOM[0].uom_id
          );
          if (tempArr && tempArr.length) {
            UOMArray = [...UOMArray, ...tempArr];
            console.log("UOMArray 3", UOMArray);
          }
        }
      }
      console.log("UOMArray 4", UOMArray);
      return UOMArray;
    },
    onSelectModifierUOM(event, cinemaIndex, categoryIndex, type) {
      if (type == "select") {
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].selectedUom = event;
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].uom_id = event.uom_id;
      } else if (type == "remove") {
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].selectedUom = "";
        this.CinemaPriceSettings[cinemaIndex].modifier_pack[
          categoryIndex
        ].uom_id = null;
      }
    },
    getModifierCategoryItems(singleCinema, category, type = null) {
      let tempArray = [];
      if (
        singleCinema &&
        category &&
        category.hasOwnProperty("mappedArray") &&
        category.mappedArray.length > 0
      ) {
        tempArray = [...category.mappedArray] || [];
      }
      if (
        type == "alternate" &&
        category &&
        category.hasOwnProperty("default_item") &&
        category.default_item &&
        category.default_item.hasOwnProperty("rm_id")
      ) {
        tempArray = tempArray.filter(
          (x) => x.rm_id != category.default_item.rm_id
        );
      }
      if (
        category.hasOwnProperty("uomList") &&
        category.uomList.length &&
        type == "alternate"
      ) {
        let newTempArr = _.cloneDeep(tempArray);
        newTempArr.map((x) => {
          if (
            !category["uomList"].some(
              (_uom) => _uom["uom_id"] == x.uom_id_threshold
            )
          ) {
            x["$isDisabled"] = true;
          }
        });
        return newTempArr;
      } else {
        return tempArray;
      }
    },
    getCategoryItems(singleCinema, category_id, category, type = null) {
      let fnbArray = [];
      if (
        singleCinema &&
        singleCinema.hasOwnProperty("fnb_item_array") &&
        singleCinema.fnb_item_array.length > 0
      ) {
        fnbArray =
          singleCinema.fnb_item_array.filter(
            (x) =>
              x.fc_id == category_id &&
              x.has_alternate_items == "N" &&
              x.isCustomization == "N" &&
              x.is_combo == "N"
          ) || [];
      }
      if (
        type == "alternate" &&
        category &&
        category.hasOwnProperty("default_item") &&
        category.default_item &&
        category.default_item.hasOwnProperty("item_id")
      ) {
        fnbArray = fnbArray.filter(
          (x) => x.item_id != category.default_item.item_id
        );
      }
      return fnbArray;
    },
    onSelectComboCategories(event, type) {
      if (this.selectedComboCategory.length == 0) {
        this.CinemaPriceSettings.forEach((x) => {
          x["combo_pack"] = [];
        });
      } else {
        if (type == "remove") {
          this.CinemaPriceSettings.forEach((x) => {
            let findIndex = x.combo_pack.findIndex(
              (index) => index.category_id == event.fc_id
            );
            if (findIndex > -1) {
              x.combo_pack.splice(findIndex, 1);
            }
          });
        } else if (type == "forceAdd") {
          this.CinemaPriceSettings.forEach((x, index) => {
            let categoryObj = {
              category_id: event.fc_id,
              category_name: event.fc_category,
              alternate_items: [],
              quantity: 1,
              min_quantity: 1,
              max_quantity: 1,
              min_max_setting: "N",
              default_item: "",
              default_item_id: null,
              default_item_name: "",
            };
            x.combo_pack.push(categoryObj);
          });
        } else {
          this.CinemaPriceSettings.forEach((x, index) => {
            this.selectedComboCategory.forEach((category) => {
              if (!x.combo_pack.some((c) => c.category_id == category.fc_id)) {
                let categoryObj = {
                  category_id: category.fc_id,
                  category_name: category.fc_category,
                  alternate_items: [],
                  quantity: 1,
                  min_quantity: 1,
                  max_quantity: 1,
                  min_max_setting: "N",
                  default_item: "",
                  default_item_id: null,
                  default_item_name: "",
                };
                x.combo_pack.push(categoryObj);
              }
            });
          });
        }
      }
    },
    onSelectModifierCategories(event, type) {
      if (this.selectedModifierCategory.length == 0) {
        this.CinemaPriceSettings.forEach((x) => {
          x["modifier_pack"] = [];
        });
      } else {
        if (type == "remove") {
          this.CinemaPriceSettings.forEach((x) => {
            let findIndex = x.modifier_pack.findIndex(
              (index) => index.category_id == event.category_id
            );
            if (findIndex > -1) {
              x.modifier_pack.splice(findIndex, 1);
            }
          });
        } else {
          console.log(
            "this.selectedModifierCategory",
            this.selectedModifierCategory
          );
          this.CinemaPriceSettings.forEach((x, index) => {
            this.selectedModifierCategory.forEach((category) => {
              if (
                !x.modifier_pack.some(
                  (c) => c.category_id == category.category_id
                )
              ) {
                let categoryObj = {
                  category_id: category.category_id,
                  category_name: category.category_name,
                  alternate_items: [],
                  quantity: 1,
                  uom_id: null,
                  selectedUom: "",
                  non_mandatory_modifier: "N",
                  default_item: "",
                  default_item_id: null,
                  default_item_name: "",
                  mappedArray: category.mappedArray,
                  uomList: [],
                };
                x.modifier_pack.push(categoryObj);
              }
            });
          });
        }
      }
    },
    onSelectCustomisation(customization, index) {
      let count = 0;
      this.customizationMap.map((x) => {
        if (x.customization_id == customization.item_id) {
          count++;
        }
      });
      if (count > 0) {
        this.customizationMap[index].selectedCustomization = "";
        this.$forceUpdate();
        console.log("this.customizationMap", this.customizationMap);
        console.log(
          "this.customizationMap[index]",
          this.customizationMap[index].selectedCustomization
        );
        return this.$toasted.show("Already selected");
      } else {
        this.customizationMap[index].customization_id = customization.item_id;
      }
    },
    onRemoveCustomisation(customization, index) {
      this.customizationMap[index].customization_id = null;
    },
    addCustomizationSetting() {
      let obj = {
        customization_id: null,
        selectedCustomization: "",
        is_compulsory: "N",
      };
      this.customizationMap.push(obj);
    },
    removeCustomizationSetting(event, index) {
      this.customizationMap.splice(index, 1);
    },
    getMovieContentLangauge: function () {
      MovieService.GetMovieContentLanguages()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
              //   "langauge"
              // ]);
              this.ContentLanguages = data.ContentLanguages;
            }
            console.log("this.ContentLanguages", this.ContentLanguages);
          } else {
            // Show Error:
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers();
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error On getMovieContentLangauge :", error);
        });
    },
    onChangeItemName(event, type) {
      this.FnbItemContent.map((x) => {
        if (x.langauge.toLowerCase() == "english") {
          if (type == "name") {
            x.item_name = event.target.value;
          } else if (type == "desc") {
            x.item_description = event.target.value;
          }
        }
      });
    },
    makeLangContainers: function () {
      this.ContentLanguages.map((x) => {
        let Obj = {
          ...x,
          item_name: "",
          item_description: "",
        };
        this.FnbItemContent.push(Obj);
        console.log("this.FnbItemContent", this.FnbItemContent);
      });
    },
    onChangeTabHandler: function (event, index) {
      this.activeClass = index;
    },
    resetFromDate(index) {
      this.CinemaPriceSettings[index].ms_fnb_price.fp_from_date = "";
    },
    resetToDate(index) {
      this.CinemaPriceSettings[index].ms_fnb_price.fp_to_date = "";
    },
    clearCustomisation() {
      this.customization_name = "";
    },
    getAlternateItems: function () {
      PosFnbService.GetAlternateItems()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.alternate_items_list = data.Records;
          } else {
          }
        })
        .catch((error) => {
          console.log("Catch Error on getAlternateItems :", error);
        });
    },
    setModalData(height, width) {
      this.set_height = height;
      this.set_width = width;
      this.showModal = !this.showModal;
    },
    onSearchFoodCategories: function () {
      if (this.searchFoodCategories && this.searchFoodCategories.length > 0) {
        this.ms_food_categories = this.ms_food_categoriesCopy.filter((x) => {
          if (
            x.fc_category
              .toLowerCase()
              .includes(this.searchFoodCategories.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.ms_food_categories = this.ms_food_categoriesCopy;
      }
    },
    onSearchCustomization: function () {
      if (this.searchCustomization && this.searchCustomization.length > 0) {
        this.customizations = this.customizationsCopy.filter((x) => {
          if (
            x.customization_name
              .toLowerCase()
              .includes(this.searchCustomization.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.customizations = this.customizationsCopy;
      }
    },
    showFnbImage: function () {
      this.$refs["preview-modal"].show();
    },
    getCurrencyCode: function (currencyid) {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id: currencyid,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getRecipeList: function () {
      let payload = {
        tableName: "ms_recipes",
        recipe_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.recipes = data.Records;
          } else {
            console.log("message", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onChangeWeekdays: function (event, keyname, index) {
      if (keyname !== "AllDays") {
        this.CinemaPriceSettings[index].weekDays["AllDays"] = false;
      }

      let len = Object.keys(this.CinemaPriceSettings[index].weekDays).length;
      if (keyname === "AllDays" && event) {
        Object.keys(this.CinemaPriceSettings[index].weekDays).map((x) => {
          x !== "AllDays"
            ? (this.CinemaPriceSettings[index].weekDays[x] = true)
            : "";
        });
      } else if (keyname === "AllDays" && !event) {
        Object.keys(this.CinemaPriceSettings[index].weekDays).map((x) => {
          x !== "AllDays"
            ? (this.CinemaPriceSettings[index].weekDays[x] = false)
            : "";
        });
      } else if (
        keyname !== "AllDays" &&
        this.CinemaPriceSettings[index].weekDays.AllDays
      ) {
        this.CinemaPriceSettings[index].weekDays["AllDays"] = false;
      }
    },
    addCinemaSetting: function (index) {
      this.getGlobalOptions();

      let cinemaSettingObj = {
        selectedCinema: "",
        selectedCinemas: [],
        cinema_id: null,
        recipe_label: "",
        currentIndex: 0,
        //ITEM COST PRICE
        itemcost_price: {
          cinema_id: "",
          v_id: "",
          item_id: "",
          costprice: "",
          fp_is_active: true,
        },
        report_code: "",
        gl_account: "",
        gl_desc: "",
        //RATE CARD
        isRoleID: true,
        combo_pack: [],
        modifier_pack: [],
        fnb_item_array: [],
        selectedCinema: "",
        cinemaList: [],
        ratecard: {
          cinema_id: null,
          frc_name: "",
          frc_amount: "",
          currency_id: null,
          frc_is_active_inclusivtax: "Y",
          frc_net_amount: 0,
          frc_total_amount: 0,
        },
        selectedChargeSettingName: "",
        pas_setting_name_list: [],
        cinemaChargesList: [],
        //FNB Pricing
        ms_fnb_price: {
          cinema_id: "",
          item_id: "",
          currency_id: "",
          fnb_rate_card_id: "",
          fp_amount: "",
          fp_total_amount: "",
          fp_from_date: new Date(),
          fp_to_date: "",
          fp_is_active: true,
        },
        weekDays: {
          AllDays: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
          sunday: true,
        },
      };

      if (this.fnb_item.is_combo == "Y") {
        this.selectedComboCategory.forEach((category) => {
          let categoryObj = {
            category_id: category.fc_id,
            category_name: category.fc_category,
            alternate_items: [],
            quantity: 1,
            min_quantity: 1,
            max_quantity: 1,
            min_max_setting: "N",
            default_item: "",
            default_item_id: null,
            default_item_name: "",
          };
          cinemaSettingObj["combo_pack"].push(categoryObj);
        });
      }

      if (this.fnb_item.has_modifiers == "Y") {
        this.selectedModifierCategory.forEach((category) => {
          let categoryObj = {
            category_id: category.category_id,
            category_name: category.category_name,
            alternate_items: [],
            quantity: 1,
            uom_id: null,
            non_mandatory_modifier: "N",
            selectedUom: "",
            default_item: "",
            default_item_id: null,
            default_item_name: "",
            mappedArray: category.mappedArray,
            uomList: [],
          };
          cinemaSettingObj["modifier_pack"].push(categoryObj);
        });
      }
      this.CinemaPriceSettings.push(cinemaSettingObj);
    },
    removeCinemaSettings: function (cinemaIndex) {
      this.CinemaPriceSettings.splice(cinemaIndex, 1);
    },
    onRemoveFnbItem: function (fnbItem, index) {
      this.CinemaPriceSettings[index].itemcost_price.item_id = "";
      this.CinemaPriceSettings[index].itemcost_price.costprice = 0;
    },
    onSelectFnbItem: function (fnbItem, index) {
      this.CinemaPriceSettings[index].itemcost_price.item_id = parseInt(
        fnbItem.recipe_id
      );

      this.getItemCostPrice(
        this.CinemaPriceSettings[index].itemcost_price.cinema_id,
        fnbItem.recipe_id,
        index
      );
    },
    getFoodCategoiresList: function () {
      let payload = {
        tableName: "ms_food_categories",
        fc_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_food_categories = data.Records;
            this.ms_food_categoriesCopy = data.Records;
          } else {
            console.log("message", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getModifierCategories: function () {
      let payload = {};
      PosFnbService.GetActiveModifiersCategoriesDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.modifierCatergories = data.Records;
          } else {
            console.log("message", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getUomList() {
      this.UomList = [];
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.UomList = data.Records;
          }
        })
        .catch((error) => {
          console.log("Error:", error);
        });
    },
    getCustomizationList: function () {
      let payload = {
        limit: null,
        currentPage: null,
        columnName: null,
        orderBy: null,
        cinema_id: null,
        searchKey: "",
        searchValue: "",
      };
      PosFnbService.GetActiveCustomizationList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.customizations = data.Records;
            this.customizationsCopy = data.Records;
          } else {
            console.log("message", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectCustomization(value) {
      this.customization_name = value.customization_name;
      this.fnb_item["customization_common_id"] = value.customization_common_id;
    },
    // setImage: function(e) {
    //   this.file = e.target.files[0];
    //   this.filename = e.target.files[0]["name"];

    //   if (this.file.type.indexOf("image/") === -1) {
    //     this.$toasted.show("Please select an image file");
    //     return;
    //   }
    //   if (typeof FileReader === "function") {
    //     const reader = new FileReader();
    //     reader.onload = event => {
    //       this.imgSrc = event.target.result;
    //       this.width = 129;
    //       this.height = 192;
    //       this.$bvModal.show("imagecropper");
    //       e.target.value = "";
    //     };
    //     reader.readAsDataURL(this.file);
    //   } else {
    //   }
    // },

    // cropImage() {
    //   // get image data for post processing, e.g. upload or setting image src
    //   this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    //   // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    //   var block = this.cropImg.split(";");
    //   // Get the content type of the image
    //   var contentType = block[0].split(":")[1]; // In this case "image/gif"
    //   // get the real base64 content of the file
    //   var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
    //   // Convert it to a blob to upload
    //   var blob1 = this.b64toBlob(realData, contentType);
    //   this.uploadImage(blob1, this.filename);
    // },
    // b64toBlob(b64Data, contentType, sliceSize) {
    //   contentType = contentType || "";
    //   sliceSize = sliceSize || 512;

    //   var byteCharacters = atob(b64Data);
    //   var byteArrays = [];

    //   for (
    //     var offset = 0;
    //     offset < byteCharacters.length;
    //     offset += sliceSize
    //   ) {
    //     var slice = byteCharacters.slice(offset, offset + sliceSize);

    //     var byteNumbers = new Array(slice.length);
    //     for (var i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i);
    //     }

    //     var byteArray = new Uint8Array(byteNumbers);

    //     byteArrays.push(byteArray);
    //   }

    //   var blob = new Blob(byteArrays, { type: contentType });
    //   return blob;
    // },

    // uploadImage: function(image, filename) {
    //   let loader = this.$loading.show();

    //   let self = this;
    //   let formData = new FormData();
    //   formData.append("image", image, filename);
    //   formData.append("imagePath", "FnB Item Image");
    //   MasterService.GlobalUploadImage(formData)
    //     .then(response => {
    //       const { data } = response;
    //       data.message ? this.$toasted.show(data.message) : "";
    //       if (data.status) {
    //         self.fnb_item.item_image_url = data.path;
    //         this.$bvModal.hide("imagecropper");
    //       }
    //       self.BaseURL = data.BaseURL;
    //     })
    //     .catch(error => {
    //       alert(
    //         "Sorry! Something went wrong. kindly contact your administrator"
    //       );
    //     })
    //     .finally(() => {
    //       setTimeout(() => loader.hide(), 1000);
    //     });
    // },
    getItemCostPrice: function (cinema_id, item_id, index) {
      if (cinema_id && item_id) {
        PosFnbService.GetItemsCostPrice({ cinema_id, item_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.CinemaPriceSettings[index].itemcost_price.costprice =
                parseFloat(data.ItemCostPrice).toFixed(
                  this.MIN_FRACTION_DIGITS
                );
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    getGlobalOptions: function () {
      MasterService.GetGlobalOptions()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map((x) => {
              if (x.go_key === "CURRENCY") {
                this.CinemaPriceSettings.map((y, index) => {
                  this.CinemaPriceSettings[index].ratecard.currency_id =
                    x.go_value || null;
                  this.CinemaPriceSettings[index].ms_fnb_price.currency_id =
                    x.go_value || null;
                });
              }
            });
            console.log(
              "this.CinemaPriceSettings :>> ",
              this.CinemaPriceSettings
            );
          } else {
            // Show Error
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          //Catch Error
          console.log("catch error on GetGlobalOptions :", error);
        });
    },
    getCinemaList: function (cine_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "ms_cinemas"
      // });
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            this.cinemaListCopy = data.Records;
            //console.log("this.cinemaList :", this.cinemaList);
            this.cinemaList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                // if (x.currency_id == null && x.currency_id == "") {
                //   this.secureStore.get("BRGLOPCU") &&
                //     this.secureStore.get("BRGLOPCU").go_value;
                // } else {
                //   this.getCurrencyCode(x.currency_id);
                // }
                this.CinemaPriceSettings[0].selectedCinemas.push(x);
                this.onDropdownChange(x, 0);
              }
            });
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    getComboCinemaList(cinema_id, cinemaIndex) {
      let payload = {
        category: null,
        cinema_id: cinema_id,
        isCombo: false,
        isEgg: "",
        isVeg: "",
        search: "",
        subCategory: null,
        skipSellableFlag: "Y",
      };

      PosFnbService.GetFnBList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data && data.status && data.Records && data.Records.Records) {
              this.CinemaPriceSettings[cinemaIndex].fnb_item_array =
                _.cloneDeep(data.Records.Records);
            } else {
              this.CinemaPriceSettings[cinemaIndex].fnb_item_array = [];
            }
          }
        })
        .catch((err) => {
          console.log("Error;", err);
          this.CinemaPriceSettings[cinemaIndex].fnb_item_array = [];
        });
    },
    // On click and Change Handler
    onDropdownChange: function (item, index) {
      // this.cinemaListCopy.push(item.cine_id);
      this.CinemaPriceSettings[index].selectedCinema = item.cine_name;
      this.CinemaPriceSettings[index].cinema_id = item.cine_id;
      this.CinemaPriceSettings[index].itemcost_price.cinema_id = item.cine_id;
      this.CinemaPriceSettings[index].ms_fnb_price.cinema_id = item.cine_id;
      this.CinemaPriceSettings[index].ratecard.cinema_id = item.cine_id;

      if (this.fnb_item.is_combo == "Y") {
        this.getComboCinemaList(item.cine_id, index);
      }
      // this.cinemaListCopy = [];
      // this.cinemaList.map((x) => {
      //   let arr = this.CinemaPriceSettings.filter((y) => {
      //     return y.cinema_id == x.cine_id;
      //   });
      //   if (arr.length == 0) {
      //     this.cinemaListCopy.push(x);
      //   }
      // });
      if (item.currency_id == null && item.currency_id == "") {
        this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value;
      } else {
        this.getCurrencyCode(item.currency_id);
      }
      this.getPasSettingName(item.cine_id, index);
    },
    getPasSettingName: function (id, index) {
      this.CinemaPriceSettings[index].pas_setting_name_list = [];
      CinemasService.GetCinemaSettingNameByCinemaId({ id })
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemaPriceSettings[index].pas_setting_name_list =
              data.Records;
          } else {
            // Show Error Message Here
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("catch error on GetCinemaCharges :", error);
        });
    },
    onChangeSettingName: function (event, item, index) {
      console.log("item :>> ", item);
      this.CinemaPriceSettings[index].selectedChargeSettingName =
        item.pas_charge_setting_name;
      console.log(
        "object :>> ",
        (this.CinemaPriceSettings[index].selectedChargeSettingName =
          item.pas_charge_setting_name)
      );
      this.getCinemaCharges(
        this.CinemaPriceSettings[index].ratecard.cinema_id,
        index
      );
    },
    OnSwitchHandler: function (event, index) {
      this.CinemaPriceSettings[index].ratecard.frc_is_active_inclusivtax =
        event;
      this.cinemaChargesCalculation(index);
    },
    onChangeRatecardAmount: function (event, index) {
      this.cinemaChargesCalculation(index);
    },
    calculatePercentageCharge: function (index) {
      let finalvalue = 1;
      this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
        if (x.pas_is_percentage === "Y") {
          finalvalue += parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    getCinemaCharges: function (id, index) {
      this.CinemaPriceSettings[index].cinemaChargesList = [];
      let payload = {
        pas_charge_setting_name:
          this.CinemaPriceSettings[index].selectedChargeSettingName,
        id: id,
      };
      CinemasService.GetCinemaChargesByCinemaId(payload)
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemaPriceSettings[index].cinemaChargesList = data.Records;
            let promises = this.CinemaPriceSettings[
              index
            ].cinemaChargesList.map((x) => {
              x["cinemacharges"] = 0;
              return x;
            });
            await Promise.all(promises).then(() => {
              this.cinemaChargesCalculation(index);
            });
          } else {
            // Show Error Message Here
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("catch error on GetCinemaCharges :", error);
        });
    },
    getFloat(val = "0", fractionDigits = this.fractionDigits) {
      let parsed = parseFloat(String(val) || "0") || parseFloat("0");
      return +parseFloat(parsed.toFixed(fractionDigits));
    },
    cinemaChargesCalculation: function (index) {
      this.CinemaPriceSettings[index].ratecard.frc_net_amount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_amount
      );
      this.CinemaPriceSettings[index].ratecard.frc_total_amount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_amount
      );
      let FinalAmount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_total_amount || 0
      );
      if (this.qfx_tax_structure) {
        let grosss = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let nets = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let misc_products = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => g.pas_is_percentage === "N")
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"));

        console.log({
          nets,
          grosss,
          misc_products,
          taxes: this.CinemaPriceSettings[index].cinemaChargesList.map(
            (x) => x
          ),
        });

        let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
        let vat_percent = this.getFloat(
          this.getSafe(() => grosss[0].pas_charge_value, 0),
          2
        );

        let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
        let net_1_percent = this.getFloat(
          this.getSafe(() => nets[0].pas_charge_value, "0"),
          2
        );

        let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
        let net_2_percent = this.getFloat(
          this.getSafe(() => nets[1].pas_charge_value, "0"),
          2
        );

        let misc_product_rate_pas_id = this.getSafe(
          () => misc_products[0].pas_id
        );
        let misc_product_rate_1 = this.getFloat(
          this.getSafe(() => misc_products[0].pas_charge_value, "0"),
          2
        );
        let misc_rate_exist =
          misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
        let amount = this.getFloat(FinalAmount);

        /** Gross */
        let G = amount;
        /** Taxable/Net */
        let E = this.getFloat(amount / (1 + vat_percent / 100));
        /** VAT */
        let F = this.getFloat((vat_percent / 100) * E);
        /** 3D/Prod */
        let B = this.getFloat(misc_product_rate_1 / (1 + vat_percent / 100));
        /** Ticket Rate */
        let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
        let A = this.getFloat((E - B) / totalPerCentOfA);
        /** Film Dev Tax */
        let C = this.getFloat((net_1_percent / 100) * A);
        /** State & Local Ent Tax */
        let D = this.getFloat((net_2_percent / 100) * A);

        console.log({
          amount,
          vat_percent,
          net_1_percent,
          net_2_percent,
          totalPerCentOfA,
          misc_rate_exist,
          misc_product_rate_1,
        });
        console.log({
          Gross: G,
          Net: E,
          VAT: F,
          FDT: C,
          SLE: D,
          "3D": B,
          TicketRate: A,
          ProductRate: B,
        });

        let NET_AMT = E;
        let BASE_RATE = A;
        let NET_1_AMT = C;
        let NET_2_AMT = D;
        let NET_3_AMT = B; // misc_product_rate_1
        let VAT_AMT = F;
        let Gross = G;

        this.CinemaPriceSettings[index].cinemaChargesList.map((x, i) => {
          if (x.pas_id == vat_pas_id) {
            x.cinemacharges = VAT_AMT;
          }
          if (x.pas_id == net_1_pas_id) {
            x["cinemacharges"] = NET_1_AMT;
          }
          if (x.pas_id == net_2_pas_id) {
            x["cinemacharges"] = NET_2_AMT;
          }
          if (x.pas_id == misc_product_rate_pas_id) {
            x["cinemacharges"] = NET_3_AMT;
          }
        });

        this.CinemaPriceSettings[index].ratecard.frc_net_amount = this.getFloat(
          BASE_RATE + NET_3_AMT
        );

        this.$forceUpdate();
      } else if (this.mif_tax_calculation) {
        let grosss = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let nets = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let misc_products = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => g.pas_is_percentage === "N")
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"));

        console.log({
          nets,
          grosss,
          misc_products,
          taxes: this.CinemaPriceSettings[index].cinemaChargesList.map(
            (x) => x
          ),
        });

        let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
        let vat_percent = this.getFloat(
          this.getSafe(() => grosss[0].pas_charge_value, 0),
          2
        );

        let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
        let net_1_percent = this.getFloat(
          this.getSafe(() => nets[0].pas_charge_value, "0"),
          2
        );

        let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
        let net_2_percent = this.getFloat(
          this.getSafe(() => nets[1].pas_charge_value, "0"),
          2
        );

        let misc_product_rate_pas_id = this.getSafe(
          () => misc_products[0].pas_id
        );
        let misc_product_rate_1 = this.getFloat(
          this.getSafe(() => misc_products[0].pas_charge_value, "0"),
          2
        );

        let all_mis_product_sum = 0;
        if (misc_products && misc_products.length) {
          all_mis_product_sum =
            this.getFloat(
              misc_products.reduce(
                (acc, { pas_charge_value }) =>
                  acc + parseFloat(pas_charge_value),
                0
              ),
              3
            ) || 0;
        }

        let misc_rate_exist =
          misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
        let amount = this.getFloat(FinalAmount);

        /** Gross */
        let G = amount;
        /** Taxable/Net */
        let E = this.getFloat(amount / (1 + vat_percent / 100));
        /** VAT */
        let F = this.getFloat((vat_percent / 100) * E);
        /** 3D/Prod */
        let B = this.getFloat(all_mis_product_sum || 0);
        /** Ticket Rate */
        let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
        let A = this.getFloat((E - B) / totalPerCentOfA);
        /** Film Dev Tax */
        let C = this.getFloat((net_1_percent / 100) * A);
        /** State & Local Ent Tax */
        let D = this.getFloat((net_2_percent / 100) * A);

        console.log({
          amount,
          vat_percent,
          net_1_percent,
          net_2_percent,
          totalPerCentOfA,
          misc_rate_exist,
          misc_product_rate_1,
        });
        console.log({
          Gross: G,
          Net: E,
          VAT: F,
          FDT: C,
          SLE: D,
          "3D": B,
          TicketRate: A,
          ProductRate: B,
        });

        let NET_AMT = E;
        let BASE_RATE = A;
        let NET_1_AMT = C;
        let NET_2_AMT = D;
        let NET_3_AMT = B; // misc_product_rate_1
        let VAT_AMT = F;
        let Gross = G;

        this.CinemaPriceSettings[index].cinemaChargesList.map((x, i) => {
          if (x.pas_id == vat_pas_id) {
            x.cinemacharges = this.getFloat(VAT_AMT, 2);
          }
          if (x.pas_id == net_1_pas_id) {
            x["cinemacharges"] = this.getFloat(NET_1_AMT, 2);
          }
          if (x.pas_id == net_2_pas_id) {
            x["cinemacharges"] = this.getFloat(NET_2_AMT, 2);
          }
          if (x.pas_is_percentage == "N") {
            let findIndex = misc_products.findIndex(
              (mis) => mis.pas_id == x.pas_id
            );

            if (findIndex > -1) {
              x.cinemacharges = parseFloat(
                misc_products[findIndex]["pas_charge_value"]
              ).toFixed(2);
            }
          }
        });

        // this.CinemaPriceSettings[index].ratecard.frc_net_amount = this.getFloat(
        //   BASE_RATE + NET_3_AMT
        // );
        this.CinemaPriceSettings[index].ratecard.frc_net_amount =
          this.getFloat(BASE_RATE);

        this.$forceUpdate();
      } else {
        this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
          if (
            this.CinemaPriceSettings[index].ratecard
              .frc_is_active_inclusivtax === "N"
          ) {
            if (x.pas_is_percentage === "Y") {
              x.cinemacharges =
                (parseFloat(
                  this.CinemaPriceSettings[index].ratecard.frc_amount
                ) *
                  parseFloat(x.pas_charge_value)) /
                100;
            }
            this.calculateNetAmount(x, "Plus", index);
          } else if (
            this.CinemaPriceSettings[index].ratecard
              .frc_is_active_inclusivtax === "Y"
          ) {
            if (x.pas_is_percentage === "Y") {
              x.cinemacharges =
                ((parseFloat(
                  this.CinemaPriceSettings[index].ratecard.frc_amount
                ) /
                  this.calculatePercentageCharge(index)) *
                  parseFloat(x.pas_charge_value)) /
                100;
            }
            this.calculateNetAmount(x, "Minus", index);
          }
          if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
            x.cinemacharges =
              parseFloat(x.pas_charge_value) *
              this.calculateTaxableCharge(index);
          } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
            x.cinemacharges = parseFloat(x.pas_charge_value);
          }
          return x;
        });
        this.$forceUpdate();
      }
    },
    calculateTaxableCharge: function (index) {
      let finalvalue = 1;
      this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
        //Pick only items that are taxable
        if (x.pas_is_percentage === "Y") {
          finalvalue -= parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    calculateNetAmount: function (x, equation, index) {
      if (equation === "Plus") {
        if (x.pas_is_percentage === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_total_amount +=
            parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          this.CinemaPriceSettings[index].ratecard.frc_total_amount +=
            parseFloat(x.pas_charge_value);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_total_amount +=
            parseFloat(x.pas_charge_value);
        }
      } else if (equation === "Minus") {
        if (x.pas_is_percentage === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_net_amount -= parseFloat(
            x.cinemacharges
          );
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          this.CinemaPriceSettings[index].ratecard.frc_net_amount -= parseFloat(
            x.pas_charge_value
          );
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_net_amount -= parseFloat(
            x.pas_charge_value
          );
        }
      }
    },
    calculatePercentageCharge: function (index) {
      let finalvalue = 1;
      this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
        if (x.pas_is_percentage === "Y") {
          finalvalue += parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    onResetForm: function () {
      this.CinemaPriceSettings = [
        {
          selectedCinema: "",
          selectedCinemas: [],
          cinema_id: null,
          recipe_label: "",
          //ITEM COST PRICE
          itemcost_price: {
            cinema_id: "",
            v_id: "",
            item_id: "",
            costprice: "",
            fp_is_active: true,
          },
          //RATE CARD

          selectedCinema: "",
          ratecard: {
            cinema_id: null,
            frc_name: "",
            frc_amount: "",
            currency_id: null,
            frc_is_active_inclusivtax: "Y",
            frc_net_amount: 0,
            frc_total_amount: 0,
          },
          selectedChargeSettingName: "",
          pas_setting_name_list: [],
          cinemaChargesList: [],
          //FNB Pricing
          ms_fnb_price: {
            cinema_id: "",
            item_id: "",
            currency_id: "",
            fnb_rate_card_id: "",
            fp_amount: "",
            fp_total_amount: "",
            fp_from_date: new Date(),
            fp_to_date: "",
            fp_is_active: true,
          },
          weekDays: {
            AllDays: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            sunday: true,
          },
        },
      ];
      this.customization_name = "";

      this.fnb_item = {
        fc_id: "",
        item_code: "",
        item_name: "",
        item_description: "",
        report_code: "",
        gl_account: "",
        gl_desc: "",
        fi_order: null,
        item_age_restriction: "",
        recipe_id: "",
        customization_common_id: null,
        is_sundry: "N",
        ready_to_serve: "N",
        is_premier_item: "N",
        is_non_sellable_product: "N",
        item_is_veg: true,
        item_is_recipe: "",
        item_image_url: "",
        includes_egg: false,
        is_package_item: false,
        item_is_active: true,
      };
      this.recipe_label = "";
      this.fc_parent_label = "";
    },
    validatePricing(showErr = true) {
      let errCount = 0;
      let errMsg = ``;

      this.CinemaPriceSettings.forEach((x, index) => {
        if (!x.selectedChargeSettingName) {
          errCount++;
          errMsg = "Please Select Charge Setting";
        }
      });

      if (errCount > 0) {
        if (showErr) {
          this.$toasted.show(errMsg);
        }
        return false;
      } else {
        return true;
      }
    },

    validateCombo(showErr = true) {
      let errorCount = 0;
      let errorMsg = "";

      if (this.fnb_item.is_combo == "Y") {
        this.CinemaPriceSettings.forEach((x) => {
          x.combo_pack.forEach((y) => {
            if (!y.category_id) {
              errorCount++;
              errorMsg = "Please Select Combo Category";
            } else if (!y.default_item_id) {
              errorCount++;
              errorMsg = "Please Select item in Combo";
            } else if (isNaN(String(y.quantity))) {
              errorCount++;
              errorMsg = "Please Select Valid item Quantity in Combo";
            } else if (
              y.min_max_setting == "Y" &&
              isNaN(String(y.min_quantity))
            ) {
              errorCount++;
              errorMsg = "Please Select Valid Min item Quantity in Combo";
            } else if (
              y.min_max_setting == "Y" &&
              isNaN(String(y.max_quantity))
            ) {
              errorCount++;
              errorMsg = "Please Select Valid Max item Quantity in Combo";
            }
          });
        });
      }

      if (errorCount > 0) {
        if (showErr) {
          this.$toasted.show(errorMsg);
        }
        return false;
      } else {
        return true;
      }
    },
    validateModifier(showErr = true) {
      let errorCount = 0;
      let errorMsg = "";

      if (this.fnb_item.has_modifiers == "Y") {
        this.CinemaPriceSettings.forEach((x) => {
          x.modifier_pack.forEach((y) => {
            if (!y.category_id) {
              errorCount++;
              errorMsg = "Please Select Modifier Category";
            } else if (!y.default_item_id) {
              errorCount++;
              errorMsg = "Please Select Default Modifier Item";
            } else if (!y.quantity || isNaN(y.quantity)) {
              errorCount++;
              errorMsg = "Please Select Valid Qty. For Modifiers";
            } else if (!y.uom_id) {
              errorCount++;
              errorMsg = "Please Select Modifier UOM";
            }
          });
        });
      }

      if (errorCount > 0) {
        if (showErr) {
          this.$toasted.show(errorMsg);
        }
        return false;
      } else {
        return true;
      }
    },
    onFinalSubmit: function (flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        let count = 0;
        if (this.customizationMap.length > 0) {
          this.customizationMap.map((x) => {
            if (!x.selectedCustomization) {
              count++;
            }
          });
        }
        if (count > 0) {
          return;
        }

        if (
          !this.validateCombo() ||
          !this.validatePricing() ||
          !this.validateModifier()
        ) {
          return;
        }

        if (valid) {
          // this.btenable = true;

          let loader = this.$loading.show();

          // if (this.fnb_item.item_is_veg == true) {
          //   this.fnb_item.includes_egg = false;
          // }
          let payload = {
            CinemaPriceSettings: this.CinemaPriceSettings,
            fnb_item: this.fnb_item,
            FnbItemContent: this.FnbItemContent,
            FnbCustomizations: this.customizationMap,
          };
          PosFnbService.AddFnbItem(payload)
            .then((response) => {
              this.btenable = false;

              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                if (flag) {
                  this.$router.push({
                    path: "/fnb/fnb-items",
                  });
                }
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            }); //message
        }
      });
    },
    CheckEmptyContent: function (fnbContent, index) {
      if (fnbContent.langauge.toLowerCase() !== "english") {
        if (fnbContent.item_name && fnbContent.item_description) {
          this.notempty[index] = true;
        } else {
          this.notempty[index] = false;
        }
      }
    },
  },
};
</script>

<style>
.clearDropDownBtn {
  position: absolute;
  left: 87%;
  z-index: 9999;
  width: auto;
  border: none;
  height: auto;
  font-size: 14px;
  color: #000000;
  font-weight: bold;
  background-color: transparent;
}

.section-collapse-box {
  border: 1px solid var(--lightgrey);
  border-radius: 10px;
  padding: 10px;
}

.customization-section-new .section-title {
  font-size: 22px;
}
.fnb-btn-edit {
  border-radius: 4px;
  border: 1px solid white;
  background-color: #3876d2;
  color: white;
  padding: 5px 25px;
}
.fnb-btn-edit:active {
  background-color: #3876d2;
  border: 1px solid #3876d2;
  color: white;
}
label {
  color: black;
}
.vat_value {
  border: none;
  background-color: white;
  border: 1px solid #d3d3d3;
  border-radius: 10px;
  padding: 5px 20px;
}
table,
th,
td {
  padding: 4px 10px;
}
.sec-1 {
  border: 2px solid #b1b4b8;
  background: white;
  border-radius: 8px;
  padding: 15px;
}
.border-new {
  border: 1px solid #d3d3d3;
  border-radius: 8px;
}
.main_border_add td {
  border: 1px solid black;
}
.new-border {
  border: 2px solid #b1b4b8;
}
label {
  color: black !important;
}
.internal-border-new {
  border: 1px solid #3876d2;
  /*background-color: #e6e6f8;*/
}
.internal-border {
  border: 1px solid #3876d2;
  background-color: #e6e6f8;
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  margin: 0 15px 15px 15px;
  padding-top: 15px;
}
.fs {
  font-size: 17px;
}
.back {
  background-color: #f5f5f5;
}
.mar {
  margin-left: 30px;
}
.border-left {
  border-left: 1px solid #b1b4b8;
}

.combo-box {
  padding: 17px;
  margin-bottom: 10px;
  background: #d3d3d342;
  border-radius: 15px;
}

.combo-inner-title {
  line-height: 1;
  font-size: 17px;
  font-weight: 500;
  color: var(--blue);
  text-transform: capitalize;
}
.noCategory {
  height: 65px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1px dotted grey;
}
.fnb-flag {
  margin-right: 27px;
  /* margin-bottom: 10px; */
}

.old_price_backup_combo tr td {
  padding: 4px 10px;
  color: black;
  font-weight: bold;
}

.overFlowHide .multiselect__single {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnBComponents/addFnbItem.vue